import React, { useState, useEffect, useRef } from "react";
import * as Constants from '../Constants.js'
import LoadingSpinnerImage from "../LoadingSpinnerImage.js";
import { TagList, Tags } from "../Tags.js";
import useClickOutside from "../useClickOutside.js";
import MultiSelectField from "../MultiSelectField.js"
import { getTaskBoardStepsCache, loadTaskBoards } from "../../TaskManager/taskBoardsCache.js";

const FieldType_Text = ({ value }) => {
    const limit = 500;
    let elip = "";

    if (value === null || value === undefined)
        return <></>;

    const str = String(value);

    if (str.length > limit)
        elip = "(...)";

    return <>{str.substring(0, limit) + elip}</>;
};

const FieldType_MainText = ({ value }) => {
    const limit = 500;
    let elip = "";

    if (value === null || value === undefined)
        return <></>;

    const str = String(value);

    if (str.length > limit)
        elip = "(...)";

    return (
        <span style={{ fontWeight: 500, color: '#333' }}>
            {str.substring(0, limit) + elip}
        </span>
    );
};

const FieldType_CategoryType = ({ value }) => {

    const limit = 500;
    let elip = "";

    if (value === null || value === undefined)
        return <></>;

    const str = String(value);

    if (str.length > limit)
        elip = "(...)";

    return (
        <span className="category-badge-type">
            {str.substring(0, limit) + elip}
        </span>
    );

}
const FieldType_Compliance_Status = ({ value }) => {

    let status = Constants.ComplianceStatuses.find((item) => item.id == value) ?? { bgColor: "", textColor: "", name: "" };

    return (
        <div style={{
            color: status.textColor,
            borderRadius: "5px",
            border: "0px",
            padding: "3px 8px",
            backgroundColor: status.bgColor,
            width: "200px",
            textAlign: "center",
            padding: "5px"
        }}>
            {status.name}
        </div>
    );
};


const FieldType_Compliance_Stage = ({ value }) => {

    let bgColor = "";

    switch (value) {
        case "Active": bgColor = "#d5f6d5"; break;
        case "Published": bgColor = "#d5f6d5"; break;
        case "Withdrawn": bgColor = "#ffd5d5"; break;
        case "In progress": bgColor = "#c0f9ff"; break;
        case "In review": bgColor = "#fff6a9"; break;
        default: break;
    }

    return (
        <div style={{
            borderRadius: "5px",
            border: "0px",
            padding: "3px 8px",
            backgroundColor: bgColor,
            width: "100px",
            textAlign: "center",
            padding: "5px"
        }}>
            {value}
        </div>
    );
};


const FieldType_Open_Tasks = ({ value, row, entityType }) => {

    let objectId = row.Id;

    return (<>

        <a target="_blank" href={`/your-medboard/task-manager/?isSlimVersion=false&showAllTasks=false&externalLinkedObjects=${entityType},${objectId}&currentEntityType=${entityType}&currentEntityId=${objectId}`}>{value}</a>


    </>);

};


const FieldType_Open_TaskCount = ({ value }) => {

  

    return (<>

        <span
            className={`task-count-badge square ${value > 0 ? "has-tasks" : "no-tasks"
                }`}
        >
            {value|| "0"}
        </span>


    </>);

};

const PdfLink = ({ name, url }) => {

    return (<>

        <div>
            <a target="_blank" href={url} style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <img src="https://medboard-public-assets.s3.eu-west-1.amazonaws.com/Media/pdf_icon.png" style={{ height: "30px", marginRight: "5px" }} />
                <span>{name}</span>
            </a>
        </div>

    </>);

}

const Link = ({ name, url }) => {

    return (<>

        <div>
            <a target="_blank" href={url} style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <span>{name}</span>
            </a>
        </div>

    </>);

}


const SRListLink = ({ value, globalContext }) => {

    let id = value.Id;
    let title = value.Title;
    let isPrivate = value.Private;
    let collaborators = value.Collaborators;
    let responsiblePerson = value.ResponsiblePerson;
    let baseLinkUrl = value.baseLinkUrl;
    let currentUserId = value.currentUserId;
    let SrSection = globalContext.data.find(item => item.Id == id).Type; // Get the section for that SR
    let finalUrl = baseLinkUrl + SrSection + "/" + id + "/";


    let permissionLinkColor = "#385898";
    let permissionToolTip = "";

    if (isPrivate == 1)
    {
        permissionToolTip = "The access to this systematic review is restricted but you have permission to access it";

        // Is the user blocked from accessing this private SR? (Not a collab and not the responsible person)
        if (collaborators != null && !collaborators.find(collab => collab.MemberId == currentUserId) && responsiblePerson != currentUserId)
        {
            permissionLinkColor = "#8f8f8f";
            permissionToolTip = "You do not have permission to access this systematic review";
        }
    }


    return (<>

        <div style={{display: "flex", wordBreak: "break-all"}}>
            <a href={finalUrl} style={{ color: permissionLinkColor, display: "flex", flexDirection: "row", alignItems: "center" }}>
                <span>{title}</span>
            </a>

            {isPrivate == 1 ? <>
                <i style={{ color: permissionLinkColor, fontSize: "8pt", cursor: "help", display: "flex", alignItems: "center" }} title={permissionToolTip} className="fas fa-lock g-ml-5"></i>
            </> : null}
                    
        </div>

    </>);

}


const RelatedReviews = ({ relatedReviews }) => {

    let hasColumnStage = false;

    if (relatedReviews.length) {
        if (relatedReviews[0].Stage) hasColumnStage = true;
    }

    return (

        <>

        {
            (relatedReviews.length) == 0 ? <>

                <div>This item wasn't found in any Systematic Review</div>

            </> : <>

                <div style={{ marginBottom: "20px" }}>
                    <div style={{ display: "flex", flexDirection: "row", fontWeight: "bold" }}>
                        <div style={{ width: "400px" }}>Systematic Review</div>

                        {hasColumnStage && <> <div style={{ width: "150px" }}>Stage</div> </>}

                        <div style={{ width: "200px" }}>Status</div>
                        <div style={{ width: "150px" }}>Created By</div>
                        <div style={{ width: "150px" }}>Reviewed At</div>
                    </div>

                    {relatedReviews.map((item, index) => (
                        <div key={index} style={{ display: "flex", flexDirection: "row", borderTop: "1px solid #ececec", padding: "3px 0px" }}>
                            <div style={{ width: "400px" }}><a href={`/your-medboard/systematic-reviews/${item.Type}/${item.SurveillanceId}/#${item.SurveillanceIdent}`}>{item.Title}</a></div>

                            {hasColumnStage && <> <div style={{ width: "150px" }}>{item.Stage}</div> </>}

                            <div style={{ width: "200px" }}><SystematicReviewStatus status={item.Status} /></div>
                            <div style={{ width: "150px" }}>{item.CreatedBy}</div>
                            <div style={{ width: "150px" }}>{item.ReviewedAt}</div>
                        </div>
                    ))}
                </div>

            </>
        }

        </>  

    );

}

const RegulatoryOtherVersions = ({ otherVersions, globalContext }) => {
    const AppContext = globalContext;

    const [isAddingUniqueIdsList, setIsAddingUniqueIdsList] = useState([]);
    const [alreadyAddedUniqueIds, setAlreadyAddedUniqueIds] = useState([]);

    const [isLoadingIds, setIsLoadingIds] = useState(true);

    useEffect(() => {
        
        setIsLoadingIds(true);

        let enumId = 0; 
        let dataUrl = "/umbraco/api/Compliance/Ids/";
        let loadIdsURL = dataUrl + `?type=${encodeURIComponent(enumId)}&`;

        if (globalContext.currentLegalManufacturerFilter) {
            loadIdsURL += "legalManufacturerId=" + globalContext.currentLegalManufacturerFilter + "&";
        }

        let requestOptions = {};

        fetch(loadIdsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        document.dispatchEvent(new Event("api:unauthorized"));
                    }
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {
                setAlreadyAddedUniqueIds(result);
            })
            .catch((error) => {
                console.error("Error fetching existing IDs: ", error);
            })
            .finally(() => {
                setIsLoadingIds(false);
            });

    }, [globalContext.currentLegalManufacturerFilter]);

    const addRegulatoryDocument = (item) => {
        let newItem = {
            Id: 0,
            UniqueId: item.UniqueId,
            Name: item.Title || item.Name,
            Type: item.Type,
            Country: item.Country,
            Regulatory_Area: item.RegulatoryArea,
            Compliance_Status: null,
            Open_Tasks: 0,
            LegalManufacturerId: globalContext.currentLegalManufacturerFilter == -1 ? null : parseInt(globalContext.currentLegalManufacturerFilter)
        };

        let dataUrl = AppContext.dataUrl;

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newItem)
        };

        setIsAddingUniqueIdsList([...isAddingUniqueIdsList, item.UniqueId]);

        fetch(dataUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((addedItem) => {
                let result = [addedItem, ...AppContext.data];
                AppContext.setData(result);

                setAlreadyAddedUniqueIds([...alreadyAddedUniqueIds, addedItem.UniqueId]);
            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {
                setIsAddingUniqueIdsList(prev => prev.filter((id) => id != item.UniqueId));
            });
    }

    return (
        <>
            {otherVersions.length === 0 ? (
                <div>This item does not have previous versions</div>
            ) : (
                <div style={{ marginBottom: "20px" }}>
                    <div style={{ display: "flex", flexDirection: "row", fontWeight: "bold" }}>
                        <div style={{ width: "120px" }}>Date</div>
                        <div style={{ width: "450px" }}>Title</div>
                        <div style={{ width: "120px", marginLeft: "30px" }}>PDF</div>
                        <div style={{ width: "150px" }}>Status</div>
                        <div style={{ width: "150px" }}>Compliance Manager</div>
                    </div>

                    {otherVersions.map((item, index) => (
                        <div
                            key={index}
                            style={{ display: "flex", flexDirection: "row", borderTop: "1px solid #ececec", padding: "3px 0px", backgroundColor: item.IsHighlighted ? '#e9f4ff' : 'transparent' }}
                        >
                            <div style={{ width: "120px" }}>
                                <FieldType_SimpleDate value={item.Date} />
                            </div>

                            <div style={{ width: "450px" }}>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#385898" }}
                                    title={item.Title}
                                    href={item.Url}
                                >
                                    {item.Title}
                                    <span
                                        style={{ fontSize: "10px", marginLeft: "10px" }}
                                        className="fas fa-external-link-alt"
                                    />
                                </a>
                            </div>

                            <div style={{ width: "120px" }}>
                                {item.MediaPath && (
                                    <a target="_blank" rel="noopener noreferrer" title="Open PDF" style={{ marginLeft: "30px" }} href={item.MediaPath}>
                                        <img
                                            src="https://medboard-public-assets.s3.eu-west-1.amazonaws.com/Media/pdf_icon.png"
                                            alt=""
                                            width="23"
                                            height="auto"
                                        />
                                    </a>
                                )}
                            </div>
                            <div style={{ width: "150px" }}>
                                <FieldType_Compliance_Stage value={item.Status} />
                            </div>
                            <div style={{ width: "150px" }}>
                                {AppContext.userRole == "Admin" ? <>
                                {isLoadingIds ? <LoadingSpinnerImage /> : isAddingUniqueIdsList.includes(item.UniqueId) ? (
                                    <LoadingSpinnerImage />
                                ) : alreadyAddedUniqueIds.includes(item.UniqueId) ? (
                                    <button style={{
                                        padding: "3px 7px",
                                        border: "1px solid #999",
                                        borderRadius: "5px",
                                        backgroundColor: "#c0c0c0"
                                    }}>
                                        Added
                                    </button>
                                ) : (
                                    <button
                                        style={{
                                            cursor: "pointer",
                                            padding: "3px 7px",
                                            border: "1px solid #999",
                                            borderRadius: "5px",
                                            backgroundColor: "#cbeeff"
                                        }}
                                        onClick={() => addRegulatoryDocument(item)}
                                    >
                                        Add
                                    </button>
                                )}

                                </> : null}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}

const StandardsOtherVersions = ({ otherVersions, globalContext }) => {

    const AppContext = globalContext;

    const [isAddingUniqueIdsList, setIsAddingUniqueIdsList] = useState([]);
    const [alreadyAddedUniqueIds, setAlreadyAddedUniqueIds] = useState([]);
    const [isLoadingIds, setIsLoadingIds] = useState(true);

    useEffect(() => {
        setIsLoadingIds(true);

        let enumId = 1; 
        let dataUrl = "/umbraco/api/Compliance/Ids/";
        let loadIdsURL = dataUrl + `?type=${encodeURIComponent(enumId)}&`;

        if (globalContext.currentLegalManufacturerFilter) {
            loadIdsURL += "legalManufacturerId=" + globalContext.currentLegalManufacturerFilter + "&";
        }

        let requestOptions = {};

        fetch(loadIdsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        document.dispatchEvent(new Event("api:unauthorized"));
                    }
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {
                setAlreadyAddedUniqueIds(result);
            })
            .catch((error) => {
                console.error("Error fetching existing IDs: ", error);
            })
            .finally(() => {
                setIsLoadingIds(false);
            });

    }, [globalContext.currentLegalManufacturerFilter]);

    const addStandard = (item) => {
        let newItem = {
            Id: 0,
            UniqueId: item.UniqueId,
            Name: item.Standard || item.Title,
            Type: item.Type,
            Compliance_Status: null,
            Open_Tasks: 0,
            LegalManufacturerId: globalContext.currentLegalManufacturerFilter == -1 ? null : parseInt(globalContext.currentLegalManufacturerFilter)
        };

        let dataUrl = AppContext.dataUrl;

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newItem)
        };

        setIsAddingUniqueIdsList([...isAddingUniqueIdsList, item.UniqueId]);

        fetch(dataUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((addedItem) => {
                let result = [addedItem, ...AppContext.data];
                AppContext.setData(result);

                setAlreadyAddedUniqueIds([...alreadyAddedUniqueIds, addedItem.UniqueId]);
            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {
                setIsAddingUniqueIdsList(prev => prev.filter((id) => id != item.UniqueId));
            });
    }


    return (
        <>
            {
                (otherVersions.length) == 0 ? <>
                    <div>This item does not have previous versions</div>
                </> : <>
                    <div style={{ marginBottom: "20px" }}>
                        <div style={{ display: "flex", flexDirection: "row", fontWeight: "bold" }}>
                            <div style={{ width: "250px" }}>Standard</div>
                            <div style={{ width: "450px" }}>Title</div>
                            <div style={{ width: "150px" }}>Status</div>
                            <div style={{ width: "150px" }}>Compliance Manager</div>
                        </div>

                        {otherVersions.map((item, index) => (
                            <div
                                key={index}
                                style={{ display: "flex", flexDirection: "row", borderTop: "1px solid #ececec", padding: "3px 0px", backgroundColor: item.IsHighlighted ? '#e9f4ff' : 'transparent' }}
                            >
                                <div style={{ width: "250px" }}>
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#385898" }}
                                        title={item.Standard}
                                        href={item.Url}
                                    >
                                        {item.Standard}
                                    </a>
                                </div>

                                <div style={{ width: "450px" }}>
                                    {item.Title}
                                </div>
                                <div style={{ width: "150px" }}>
                                    <FieldType_Compliance_Stage value={item.Status} />
                                </div>

                                <div style={{ width: "150px" }}>
                                    {AppContext.userRole == "Admin" ? <>
                                    {isLoadingIds ? <LoadingSpinnerImage /> : isAddingUniqueIdsList.includes(item.UniqueId) ? (
                                        <LoadingSpinnerImage />
                                    ) : alreadyAddedUniqueIds.includes(item.UniqueId) ? (
                                            <button style={{
                                            padding: "3px 7px",
                                            border: "1px solid #999",
                                            borderRadius: "5px",
                                            backgroundColor: "#c0c0c0"
                                        }}>
                                            Added
                                        </button>
                                    ) : (
                                        <button
                                            style={{
                                                cursor: "pointer",
                                                padding: "3px 7px",
                                                border: "1px solid #999",
                                                borderRadius: "5px",
                                                backgroundColor: "#cbeeff"
                                            }}
                                            onClick={() => addStandard(item)}
                                        >
                                            Add
                                        </button>
                                        )}
                                    </> : null}
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            }
        </>
    );
}
const SystematicReviewStatus = ({ status }) => {

    let className = "badge ";
    let statusText = "";

    switch (status) {
        case "Pending":
            className += "med-status-pending ";
            statusText = "Pending";
            break;
        case "NotRelevant": 
            className += "med-status-not-relevant";
            statusText = "Not Relevant After Screening";
            break;
        case "Relevant": 
            className += "med-status-relevant";
            statusText = "Relevant After Screening";
            break;
        case "RelevantFullTextNotIncluded": 
            className += "med-status-ftni";
            statusText = "Not Relevant After Full Review";
            break;
        case "RelevantFullTextIncluded":
            className += "med-status-relevent-full-text";
            statusText = "Relevant After Full Review";
            break;
        default: break;
    }


    return (<>

        <span className={className} style={{ fontSize: "0.8rem" }}>{statusText}</span>

    </>);

}





const FieldType_Submission_Status = ({ value }) => {

    let bgColor = "";
    let color = "white";
    let text = "";

    switch (value) {
        case 0:
            bgColor = "#9dc3e6";
            color = "#333";
            text = "Preparation";
            break;
        case 1:
            bgColor = "#2e75b6";
            text = "Submitted";
            break;
        case 2:
            bgColor = "#ffc000";
            color = "#333";
            text = "Questions";
            break;
        case 3:
            bgColor = "#548235";
            text = "Completed";
            break;
        default:
            break;
    }

    return (
        <div style={{
            color: color,
            borderRadius: "5px",
            border: "0px",
            padding: "3px 8px",
            backgroundColor: bgColor,
            width: "100px",
            textAlign: "center",
            padding: "5px"
        }}>
            {text}
        </div>
    );
};



const FieldType_Submission_Priority = ({ value }) => {

    let bgColor = "";
    let text = "";
    let color = "";
    

    switch (value) {
        case 1: text = "High"; bgColor = "#d1153a"; color = "white"; break;
        case 2: text = "Medium"; bgColor = "#f7b204"; break;
        case 3: text = "Low"; bgColor = "#48ca94"; break;
        case 4: text = "None"; bgColor = "#f0f0f0"; break;
        default: break;
    }

    return (
        <div style={{
            color: color,
            borderRadius: "5px",
            border: "0px",
            padding: "3px 8px",
            backgroundColor: bgColor,
            width: "100px",
            textAlign: "center",
            padding: "5px"
        }}>
            {text}
        </div>
    );
};







const FieldType_Submissions_Type = ({ value }) => {

    let type = Constants.SubmissionsTypes.find(t => t.id == value);

    return (
        <div style={{
            color: type.textColor,
            borderRadius: "5px",
            border: "0px",
            padding: "3px 8px",
            backgroundColor: type.bgColor,
            width: "100px",
            textAlign: "center",
            padding: "5px"
        }}>
            {type.name}
        </div>
    );

}






const FieldType_DateList = ({ value }) => {

    if (value == null || value == "")
        return "";

    const date = new Date(value);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]; // To always be in English, not locale dependant
    const month = monthNames[date.getUTCMonth()];
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();

    return `${day} ${month} ${year}`;

}


const FieldType_SimpleDate = ({ value }) => {

    if (value == null || value == "")
        return "";

    const date = new Date(value);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;

}


const FieldType_DateTime = ({ value }) => {

    if (value == null || value === "")
        return "";

    const date = new Date(value);

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

// Same shape as FieldType_DateList/FileUploadedOn etc. (UTC-based), just with minute
// precision added: YYYY-MM-DD HH:MM.
const FieldType_DateTimeMinutes_UTC = ({ value }) => {

    if (value == null || value === "")
        return "";

    const date = new Date(value);
    const pad = (n) => String(n).padStart(2, '0');

    return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
}
const FieldType_DateTimeMinutes_UserTimeZone = ({ value }) => {
    if (value == null || value === "") return "";

    const date = new Date(value);
    if (isNaN(date.getTime())) return "";

    return new Intl.DateTimeFormat('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).format(date);
};


const FieldType_TimelineDate = ({ value }) => {
    if (!value?.DateValue) return "";

    const date = new Date(value.DateValue);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
}

const FieldType_MultipleTimelineDates = ({ value }) => {
    if (!value || value.length === 0) return null;

    return (
        <div style={{maxHeight: "200px", overflowY: "auto"}}>
            <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                {value.map((item, index) => {
                    if (!item?.DateValue) return null;
                    const date = new Date(item.DateValue);
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    const year = date.getFullYear();

                    return (
                        <li key={index} style={{ marginBottom: '8px' }}>
                            <strong>{year}-{month}-{day}:</strong> {item.DateTitle}
                            {item.DateDescription && (
                                <div style={{ fontSize: '0.85em', color: '#666' }}>
                                    {item.DateDescription}
                                </div>
                            )}
                        </li>
                    );
                })}
            </ul>
        
        </div>

    );
}

const FieldType_MediaPath = ({ value }) => {

    const { MediaPath, MedboardResourceId } = value;

    if ((MediaPath == null || MediaPath == "") && (MedboardResourceId == null || MedboardResourceId == ""))
        return "";

    return <><i className="far fa-file-pdf"></i></>;

}

const FieldType_PdfIndicator = ({ value }) => {

    if (value == null || value == "")
        return "";

    return <><i className="far fa-file-pdf" style={{ color: "#a0aec0" }}></i></>;

}

// Rich-text Description, stripped of HTML and clipped to a 1000-character preview.
const FieldType_TruncatedDescription = ({ value }) => {

    if (value == null || value == "")
        return "";

    const plainText = value.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

    if (plainText.length <= 1000)
        return plainText;

    return plainText.substring(0, 1000) + "...";

}

const FieldType_DocumentLinkWithName = ({ value }) => {
    const { Filename, FileUrl } = value;

    const iconMap = {
        pdf: 'fas fa-file-pdf text-danger',
        doc: 'fas fa-file-word text-primary',
        docx: 'fas fa-file-word text-primary',
        xls: 'fas fa-file-excel text-success',
        xlsx: 'fas fa-file-excel text-success',
        ppt: 'fas fa-file-powerpoint text-warning',
        pptx: 'fas fa-file-powerpoint text-warning',
        png: 'fas fa-file-image text-info',
        jpg: 'fas fa-file-image text-info',
        jpeg: 'fas fa-file-image text-info',
        tiff: 'fas fa-file-image text-info',
        tif: 'fas fa-file-image text-info',
        ris: 'fas fa-file-alt text-info',
        txt: 'fas fa-file-alt text-info',
        csv: 'fas fa-file-alt text-success'
    };

    const getFileIcon = (filename) => {
        const ext = filename?.split('.').pop().toLowerCase();
        return iconMap[ext] || 'fas fa-file text-secondary';
    };

    return (
        <a target="_blank" href={FileUrl} rel="noopener noreferrer">
            <span className={`${getFileIcon(Filename)} g-mr-10`}></span>
            {Filename}
        </a>
    );
};



const FieldType_DocumentLink = ({ value }) => {

    const { LinkedToEntity, EntityUrl, EntityType } = value;

    if(EntityType == "Certificate")
        return <><a href={EntityUrl}><span title="Certificate" className="far fa-clipboard g-font-size-14" style={{ marginRight: '20px', color: '#585f69' }}></span>{LinkedToEntity}</a></>;
    else if (EntityType == "Submission")
        return <><a href={EntityUrl}><span title="Submission" className="fas fa-file-import g-font-size-14" style={{ marginRight: '20px', color: '#585f69' }}></span>{LinkedToEntity}</a></>;
    else
        return <><a href={EntityUrl}><span title="Operator" className="far fa-building g-font-size-14" style={{ marginRight: '20px', color: '#585f69' }}></span>{LinkedToEntity}</a></>;

};



const FieldType_User = ({ value, users, size = "big" }) => {

    let userId = value;
    let user = users.find((item) => item.Id == userId);

    return (
        <>
            {user ? (
                <div
                    className={
                        "user-initials-circle " +
                        (size == "small" ? "user-initials-circle-small" : "")
                    }
                    style={{ backgroundColor: user?.IsItMe ? "#0176b9" : "#e7e7e7", color: user?.IsItMe ? "white" : "black" }}
                    title={user?.Name}
                >
                    {user?.Initials}
                </div>
            ) : null}
        </>
    );
}






const FieldType_FullUser = ({ value, users, size = "big" }) => {

    let userId = value;
    let user = users.find((item) => item.Id == userId);

    return (
        <>
            {user && (
                <div style={{ display: "flex", alignItems: "center", gap: "8px", background: "#f7fafc", border: "1px solid #edf2f7", padding: "4px 5px", borderRadius: "8px", width: "fit-content" }}>
                    <div
                        className={`user-initials-circle ${size === "small" ? "user-initials-circle-small" : ""}`}
                        style={{
                            backgroundColor: user.IsItMe ? "#0176b9" : "#e7e7e7",
                            color: user.IsItMe ? "white" : "black"
                        }}
                        title={user.Name}
                    >
                        {user.Initials}
                    </div>
                    <span style={{fontWeight: "600"} }>{user.Name}</span>
                </div>
            )}
        </>
    );
}






const FieldType_SRReviewMode = ({ value }) => {

    if (value == null || value == [])
        return "";

    let mode = value.Mode;
    let MostRecentContent = value.MostRecentContent;
    let lastMatch = "No information yet";


    function isCurrentDay(date) {
        // Get the current date
        const currentDate = new Date();

        // Extract year, month, and day from the current date
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();
        const currentDay = currentDate.getDate();

        // Extract year, month, and day from the given date
        const givenYear = date.getFullYear();
        const givenMonth = date.getMonth();
        const givenDay = date.getDate();

        // Compare year, month, and day
        return currentYear === givenYear && currentMonth === givenMonth && currentDay === givenDay;
    }

    function daysPassedSince(date) {
        // Get the current date
        const currentDate = new Date();

        // Calculate the difference in milliseconds
        const timeDifference = currentDate - date;

        // Convert the difference from milliseconds to days
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

        return daysDifference;
    }


    let MostRecentContentDate = new Date(MostRecentContent);

    if (MostRecentContent)
    {
        if (isCurrentDay(MostRecentContentDate))
        {
            lastMatch = "Today";
        }
        else
        {
            let days = daysPassedSince(MostRecentContentDate);
            if (days == 0)
                days = 1;

            lastMatch = days + " day" + (days > 1 ? "s" : "") + " ago";
        }

    }

 
    if (mode == 1) {
        return <span className="ellipsis" title="One time" style={{ cursor: "help", border: "0px", textAlign: "center", fontSize: "11px", padding: "2px 0px", display: "inline-flex" }}>
            <span className="g-mr-6" style={{ color: "#777", fontSize: "9px", borderRadius: "25px", border: "1px solid #dbdbdb", width: "19px", height: "19px", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
                1
            </span>
            One Time
        </span>;
    }

    if (mode == 2) {
        return <span title={`Continuous - Last match: ${lastMatch}`} className="ellipsis" style={{ cursor: "help", border: "0px", textAlign: "center", fontSize: "11px", padding: "2px 6px 2px 0px", display: "inline-flex" }}>
            <i className="fas fa-sync-alt g-mr-6" style={{ color: "#777", fontSize: "9px", borderRadius: "25px", border: "1px solid #dbdbdb", width: "19px", height: "19px", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}></i>
            Continuous
        </span>;
    }

}



const FieldType_SRCategory = ({value}) => {

    let categories = value.Categories;
    let type = value.Type;

    let category = categories.find(item => item.category == type);

    return category != undefined ?
        <div className="smart_surveillance-category ellipsis" title={category.name}>{category.name}</div>
        : "";
}


const FieldType_SRResponsiblePerson = ({ value, users }) => {

    let userId = value.ResponsiblePerson;
    let currentUserId = value.currentUserId;

    let user = users.find((user) => user.Id == userId);

    let name = user ? user.Name : "";
    let letters = user ? user.Initials : "";

    let activeClass = userId == currentUserId ? "responsible-person_active" : "responsible-person_inactive";


    return <div className={`responsible-person ${activeClass}`} title={name}>{letters}</div>
}


const FieldType_SRNotification = ({ value, globalContext }) => {

    let id = value.Id;
    let notificationId = value.NotificationId;
    let isPrivate = value.Private;
    let collaborators = value.Collaborators;
    let responsiblePerson = value.ResponsiblePerson;
    let currentUserId = value.currentUserId;
    const [isWorking, setIsWorking] = useState(false);
    let hasAccess = true;
    if (isPrivate == 1) {
        if (collaborators != null && !collaborators.find(collab => collab.MemberId == currentUserId) && responsiblePerson != currentUserId) {
            hasAccess = false;
        }
    }
    const setItemNotifications = (e, id, state) => {

        e.preventDefault();
        e.stopPropagation();

        let notificationsUrl = globalContext.dataTableStructure.notificationsUrl + `?` +
            `id=${encodeURIComponent(id)}&` +
            `addNotification=${state}`;

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        };

        setIsWorking(true);

        fetch(notificationsUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result != false) {
                    // Update the item in the existing data array
                    const updatedDataArray = globalContext.data.map(item => {
                        if (item.Id == id)
                            item.NotificationId = result == true ? null : result; // true means removed successfully, number means added, false means error
                        return item;
                    });

                    globalContext.setData(updatedDataArray);
                        
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsWorking(false);
            });

    }


    return <>
        
        <div style={{ textAlign: "center" }}>

            {isWorking ? (
                <LoadingSpinnerImage />
            ) : (
                <>
                        {hasAccess ? (
                            notificationId ? (
                                <span
                                    className="subscribe-bell-icon"
                                    title="Click to disable notifications"
                                    onClick={(e) => setItemNotifications(e, id, false)}
                                >
                                    <i className="fas fa-bell"></i>
                                </span>
                            ) : (
                                <span
                                    className="subscribe-bell-icon"
                                    title="Click to enable notifications"
                                    onClick={(e) => setItemNotifications(e, id, true)}
                                >
                                    <i className="fas fa-bell-slash"></i>
                                </span>
                            )
                        ) : (
                                <span
                                    className="subscribe-bell-icon"
                                    style={{ color: "#8f8f8f", pointerEvents: "none"}}
                                    title="You do not have permission to access this systematic review"
                                >
                                    <i className="fas fa-bell-slash"></i>
                                </span>
                    )}
                </>
            )}



            
        </div>

    </>

}




const FieldType_Country = ({ value }) => {

    const { CountryName, CountryUrl, FlagLink } = value;
    return (<>

        <div>
            <a target="_blank" href={CountryUrl} style={{ textDecoration: "none", fontWeight: "500" }} >
                <img className="countryFlag" src={FlagLink} style={{ height: "20px", marginRight: "5px" }} />
                {CountryName}
            </a>
        </div>

    </>);

}



const FieldType_CountryLinkFilterRegistrations = ({ value }) => {
    const { CountryName, CountryId, FlagLink } = value;

    const isCountryOne = CountryId === 1 || CountryId === '1';

    const innerContent = (
        <>
            <img className="countryFlag" src={FlagLink} alt={`${CountryName} flag`} style={{ height: "20px", marginRight: "5px" }} />
            {CountryName}
        </>
    );

    return (
        <div>
            {isCountryOne ? (
                <span style={{ fontWeight: "500" }}>
                    {innerContent}
                </span>
            ) : (
                <a target="_blank" rel="noreferrer" style={{ fontWeight: "500" }}
                    href={`/your-medboard/country-registrations/registrations/?filter[CountryId]=${CountryId}`}>
                    {innerContent}
                </a>
            )}
        </div>
    );
}







const FieldType_SRItemMenu = ({value, globalContext}) => {

    let id = value.Id;
    let notificationId = value.NotificationId;
    let iconAreaSize = "30";
    const [isWorking, setIsWorking] = useState(false);
    let isPrivate = value.Private;
    let collaborators = value.Collaborators;
    let responsiblePerson = value.ResponsiblePerson;
    let currentUserId = value.currentUserId;
    let hasAccess = true;
    if (isPrivate == 1) {
        if (collaborators != null && !collaborators.find(collab => collab.MemberId == currentUserId) && responsiblePerson != currentUserId) {
            hasAccess = false;
        }
    }
    const showMenu = (state, e) => {

        e.preventDefault();
        e.stopPropagation();


        const setItemNotifications = (id, state) => {

            let notificationsUrl = globalContext.dataTableStructure.notificationsUrl + `?` +
                `id=${encodeURIComponent(id)}&` +
                `addNotification=${state}`;

            let requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
            };

            setIsWorking(true);

            fetch(notificationsUrl, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((result) => {

                    if (result != false) {
                        // Update the item in the existing data array
                        const updatedDataArray = globalContext.data.map(item => {
                            if (item.Id == id)
                                item.NotificationId = result == true ? null : result; // true means removed successfully, number means added, false means error
                            return item;
                        });

                        globalContext.setData(updatedDataArray);
                        
                    }

                })
                .catch((error) => {
                    // Handle any errors that occurred during the fetch
                    console.log("error: " + error);
                })
                .finally(() => {
                    setIsWorking(false);
                });

        }


        const removeFromProject = (id) => {

            let removeFromProjectUrl = globalContext.srProjectApiUrl + "ProjectsSRs/?id=" + globalContext.srProjectIdFilter + "&srId=" + id;

            let requestOptions = {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
            };

            setIsWorking(true);

            fetch(removeFromProjectUrl, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.text();
                })
                .then((result) => {

                    if (result !== false) {
                        globalContext.setData(prev => prev.filter(item => item.Id != id));
                    }

                })
                .catch((error) => {
                    // Handle any errors that occurred during the fetch
                    console.log("error: " + error);
                })
                .finally(() => {
                    setIsWorking(false);
                });

        }
        

        let popupWidth = 155;

        let clickedElement = e.currentTarget;
        const rect = clickedElement.getBoundingClientRect();
        let top = (rect.top + window.scrollY + 10) + "px";
        let left = (rect.left + window.scrollX + (iconAreaSize/2) - popupWidth) + "px";


        let menu = <div className="sr-item-context-menu" style={{ width: popupWidth + "px",  position: "fixed", left: left, top: top, }}>


            {hasAccess ? <>
                {notificationId ? <>
                    <div className="sr-item-context-menu-option" onClick={() => setItemNotifications(id, false)}>Turn off notifications</div>
                </> : <>
                    <div className="sr-item-context-menu-option" onClick={() => setItemNotifications(id, true)}>Turn on notifications</div>
                </>}
            </> : null}

            {globalContext.srProjectIdFilter ? 
                <div className="sr-item-context-menu-option" onClick={() => removeFromProject(id)}>Remove from group</div>
                : null
            }

            {hasAccess ? <>
                <div className="dropdown-divider"></div>

                <div className="sr-item-context-menu-option" onClick={(e) => openItemDetails(id, e)}>Tags & Linked items</div>

                <div className="dropdown-divider"></div>

                <div className="sr-item-context-menu-option" onClick={() => showConfirmDelete(top, left)}>Delete</div>
            </> : null}

        </div>;


        
        globalContext.setRowContextualMenu(menu);
        globalContext.setIsRowContextualMenuVisible(true);
      

    }



    const showConfirmDelete = () => {

        globalContext.setSelectedSystematicReviewToDelete(globalContext.data.find(item => item.Id == id));
        globalContext.showRemoveItemPopup(true);
        globalContext.setIsRowContextualMenuVisible(false);

    }



    const openItemDetails = (itemId, e) => {

        e.stopPropagation();
        e.preventDefault();

        let ignoreCustomLoadFunction = true;

        globalContext.loadItemDetails(itemId, e, ignoreCustomLoadFunction);

    }





    return <>
        
        <div style={{ textAlign: "center", display: (hasAccess || globalContext.srProjectIdFilter) ? "block" : "none" }}>
            {isWorking ? <>
                <LoadingSpinnerImage />
            </> : <>
                <span className="inline-options-icon" onClick={(e) => showMenu(true, e)}>
                    <i className="fa fa-ellipsis-v"></i>
                </span>
            </>}
        </div>

    </>

}



const FieldType_SRPendingItems = ({ value }) => {

    return <>
        
        <div
            style={{
                textAlign: "center",
                padding: "4px 7px",
                borderRadius: "10px",
                fontSize: "0.9rem",
                fontWeight: 500,
                display: "inline-block",
                backgroundColor: value > 0 ? "#fff3cd" : "#d4edda",
                color: value > 0 ? "#856404" : "#155724"
            }}
        >
            {value > 0 ? value : value}
        </div>

    </>

}








const FieldType_SRProjectsItemMenu = ({value, globalContext}) => {

    let id = value.Id;
    let archived = value.Archived;
    let iconAreaSize = "30";
    const [isWorking, setIsWorking] = useState(false);


    const closeMenu = () => {

        globalContext.setRowContextualMenu(null);
        globalContext.setIsRowContextualMenuVisible(false);

    }

    const showMenu = (state, e) => {

        e.preventDefault();
        e.stopPropagation();

        
        const openEditPopup = (e) => {

            e.preventDefault();
            e.stopPropagation();

            globalContext.loadItemDetails(id);

            closeMenu();

        }


        const setArchiveState = (state) => {

             let url = globalContext.dataTableStructure.dataUrl + `?` +
                `id=${encodeURIComponent(id)}&` +
                `archive=${encodeURIComponent(state)}&`;

            let requestOptions = {
                method: "PATCH",
                headers: { "Content-Type": "application/json" },
            };

            setIsWorking(true);

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.text();
                })
                .then((result) => {

                    // if state changes it always removes the item from the current list
                    globalContext.setData(prev => prev.filter(item => item.Id != id));
                    closeMenu();
                        
                })
                .catch((error) => {
                    // Handle any errors that occurred during the fetch
                    console.log("error: " + error);
                })
                .finally(() => {
                    setIsWorking(false);
                });

        }



        let popupWidth = 100;

        let clickedElement = e.currentTarget;
        const rect = clickedElement.getBoundingClientRect();
        let top = (rect.top + window.scrollY + 10) + "px";
        let left = (rect.left + window.scrollX + (iconAreaSize/2) - popupWidth) + "px";


        let menu = <div className="sr-item-context-menu" style={{ width: popupWidth + "px",  position: "fixed", left: left, top: top, }}>
            <div className="sr-item-context-menu-option" onClick={(e) => openEditPopup(e)}>Edit</div>
            <div className="sr-item-context-menu-option" onClick={() => setArchiveState(archived ? false : true)}>{archived ? "Unarchive" : "Archive"}</div>
            <div className="sr-item-context-menu-option" onClick={() => showConfirmDelete()}>Delete</div>
        </div>;


        globalContext.setRowContextualMenu(menu);
        globalContext.setIsRowContextualMenuVisible(true);

    }



    const showConfirmDelete = () => {

        globalContext.setSelectedSRProjectToDelete(globalContext.data.find(item => item.Id == id));
        globalContext.showRemoveItemPopup(true);
        globalContext.setIsRowContextualMenuVisible(false);

    }



    return <>
        
        <div style={{ textAlign: "center" }}>
            {isWorking ? <>
                <LoadingSpinnerImage />
            </> : <>
                <span className="inline-options-icon" onClick={(e) => showMenu(true, e)}>
                    <i className="fa fa-ellipsis-v"></i>
                </span>
            </>}
        </div>

    </>

}




const LinkFileToSubmission = ({ value, globalContext }) => {

    const [isLinking, setIsLinking] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    let CertificateFileId = value.CertificateFileId;
    let fileKey = value.FileKey;
    let allSubmissionFilesIds = value.allSubmissionFilesIds;

    let fileAlreadyAdded = allSubmissionFilesIds.find(item => item == fileKey);


    const link = async () => {

        setError(false);
        setIsLinking(true);

        let result = await globalContext.actionMethodForSubmissions(CertificateFileId);

        setIsLinking(false);

        if (result == true)
            setSuccess(true);
        else
            setError(true);

    }


    return <>

        {fileAlreadyAdded ? <>

            <span className="linked-to-submission">Added</span>

        </> : <>

            {success ? <>
                <span className="linked-to-submission">Added</span>
            </> : <>
                {isLinking ? <>
                    <div><LoadingSpinnerImage /></div>
                </> : <>
                    <span onClick={link} className="link-to-submission" title="Add file to current submission folder">Add</span>
                </>}
            </>}

        </>}



        {error && <><br/><span style={{fontSize: "9px"}}>There was a problem linking...</span></> }
    </>

}



const FieldType_Compliance_LegalManufacturer = ({ value, globalContext }) => {

    let name = "";

    if (globalContext.legalManufacturers.length > 0) {

        let lm = globalContext.legalManufacturers.find(lm => lm.EstablishmentId == value);
        if (lm)
            name = lm.Establishment;
    }

    return <span>{name}</span>

}




const FieldType_TagList = ({ value }) => {

    return <>

        <TagList tags={value} />

    </>

}



const FieldType_CustomUserFieldSingleSelect = ({ value }) => {
    return <FieldType_CustomUserFieldMultiSelect value={value} />
}

const FieldType_CustomUserFieldMultiSelect = ({ value }) => {


    const getIdealTextColor = (hexColor) => {

        if (!hexColor || hexColor == "")
            hexColor = "#ffffff";

        // Remove #
        const hex = hexColor.replace("#", "");

        // Convert hex to RGB
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        // Calculate perceived brightness
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;

        return brightness > 128 ? "#363636" : "#ffffff";
    };


    let CustomField = value.CustomField;
    let CustomFieldAnswers = value.CustomFieldAnswers ?? [];

    let answerIds = CustomFieldAnswers?.map(answer => answer.DropdownId) ?? [];
    let answerValues = CustomField.DropdownValues?.filter(value => answerIds.includes(value.Id) ?? []);

    // Single select or empty answer
    if (answerValues.length <= 1)
        return <>
            <div style={{ overflow: "hidden", whiteSpace: "nowrap", width: "100%", }}>
                {answerValues.map((answer, index) => (<div key={index}>
                    <div style={{ padding: "3px 8px", borderRadius: "5px", textAlign: "center", backgroundColor: answer.BackgroundColor, color: getIdealTextColor(answer.BackgroundColor) }} className="ellipsis" title={answer.DropdownValue}>{answer.DropdownValue}</div>
                </div>))}
            </div>
        </>

    // Multiselect multiple answers
    return <>
        <div style={{display: "flex", flexDirection: "column", maxHeight: "100px", overflowY: "auto", paddingRight: "4px", width: "100%"}}>
            {answerValues.map((answer, index) => (
                <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <i className="fas fa-circle" style={{fontSize: "6px", marginRight: "4px", color: "#777"}}></i>
                    <div className="ellipsis" title={answer.DropdownValue}>{answer.DropdownValue}</div>
                </div>))}
        </div>
    </>
}






const FieldType_CustomUserFieldsView = ({ globalContext, isEditing = false }) => {

    let customFields = globalContext.currentItem.CustomFields ?? [];


    return <>

        {customFields.map((field, index) =>

            <div key={index}>

                <label style={{ display: "block", fontSize: "11px", fontWeight: "600", color: "rgb(160, 174, 192)", textTransform: "uppercase", marginBottom: "2px" }} >{field.Name}</label>
                    
                {field.CustomFieldType == 0 ? <FieldType_CustomUserFieldEdit_Text field={field} globalContext={globalContext} forceIsEditing={isEditing} />: null}
                {field.CustomFieldType == 1 ? <FieldType_CustomUserFieldEdit_SingleSelect field={field} globalContext={globalContext} forceIsEditing={isEditing} />: null}
                {field.CustomFieldType == 2 ? <FieldType_CustomUserFieldEdit_MultiSelect field={field} globalContext={globalContext} forceIsEditing={isEditing} />: null}
                {field.CustomFieldType == 3 ? <FieldType_CustomUserFieldEdit_Date field={field} globalContext={globalContext} forceIsEditing={isEditing} />: null}

            </div>

        )}

    </>

    
}










const FieldType_CustomUserFields = ({
    globalContext,
    isAdd = false,
    forceIsEditing = null,
    classModuleTitle = "",
    displayFieldOnly = false
}) => {

    let customFields;

    if (isAdd)
        customFields = globalContext.newItemCustomFields;
    else
        customFields = globalContext.currentItem.CustomFields ?? [];



    const renderFieldEditor = (field) => {

        if (field.CustomFieldType == 0)
            return <FieldType_CustomUserFieldEdit_Text field={field} globalContext={globalContext} isAdd={isAdd} forceIsEditing={forceIsEditing} />;

        if (field.CustomFieldType == 1)
            return <FieldType_CustomUserFieldEdit_SingleSelect field={field} globalContext={globalContext} isAdd={isAdd} forceIsEditing={forceIsEditing} />;

        if (field.CustomFieldType == 2)
            return <FieldType_CustomUserFieldEdit_MultiSelect field={field} globalContext={globalContext} isAdd={isAdd} forceIsEditing={forceIsEditing} />;

        if (field.CustomFieldType == 3)
            return <FieldType_CustomUserFieldEdit_Date field={field} globalContext={globalContext} isAdd={isAdd} forceIsEditing={forceIsEditing} />;

        return null;

    };

    const renderField = (field, index) => {

        const fieldEditor = renderFieldEditor(field);

        if (isAdd) {

            return displayFieldOnly ? (

                <>{fieldEditor}</>

            ) : (

                <div key={index} style={{ width: "100%", marginBottom: "20px" }} >
                    {field.Name}
                    <br />
                    {fieldEditor}
                </div>

            );

        }

        return displayFieldOnly ? (

            <>{fieldEditor}</>

        ) : (

            <div key={index} className="view-task-field" >
                <div className="view-task-field-line">

                    <div className={`view-task-field-title ${classModuleTitle}`} >
                        {field.Name}
                    </div>

                    <div className="view-task-field-value">
                        <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
                            {fieldEditor}
                        </div>
                    </div>

                </div>
            </div>

        );

    };



    return (

        <>
            {isAdd ? (
                <>
                    {customFields.map(renderField)}
                </>
            ) : (
                <div style={{ marginBottom: "100px" }}>
                    {customFields.map(renderField)}
                </div>
            )}
        </>

    );


}





const FieldType_CustomUserFieldEdit_Text = ({ field, globalContext, isAdd = false, forceIsEditing = null }) => {

    const fieldId = isAdd ? field.CustomFieldId : field.Id; // on Add the field id comes from globalContext.newItemCustomFields, on Edit comes from globalContext.currentItem.CustomFields
    const initialValue = isAdd ? "" : globalContext.currentItem.CustomFieldsAnswers?.find(item => item.CustomFieldId == fieldId)?.Value ?? "";
    const [value, setValue] = useState(initialValue)
    const [isEditingField, setIsEditingField] = useState(forceIsEditing != null ? forceIsEditing : isAdd ? true : false);

    let entityId = null;
    let customFieldsAnswers;
    const fieldRef = useRef(null);


    const changeValue = (val) => {

        setValue(val);

        // Initialize

            if (isAdd) {
                customFieldsAnswers = globalContext.newItemCustomFieldsAnswers;
            }
            else {
                entityId = globalContext.currentItem.Id;
                customFieldsAnswers = globalContext.currentItem.CustomFieldsAnswers ?? [];
            }


        // Process

            // Answer doesn't exist yet?
            if (!customFieldsAnswers.find(item => item.CustomFieldId == fieldId)) {
                customFieldsAnswers = _addCustomFieldsAnswersItem(customFieldsAnswers, fieldId, entityId);
            }

            customFieldsAnswers = customFieldsAnswers.map(item => item.CustomFieldId != fieldId ? item : { ...item, Value: val });


        // Store


            if (isAdd) {
                globalContext.setNewItemCustomFieldsAnswers(customFieldsAnswers);
            }
            else {
                globalContext.setCurrentItem({
                    ...globalContext.currentItem,
                    CustomFieldsAnswers: customFieldsAnswers
                });
            }


    }


    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);
        setTimeout(() => {
            // We need this timeout because the ref for the edit field isn't immediately available
            fieldRef.current.selectionStart = 0;
            fieldRef.current.selectionEnd = 0;
        }, 10);
    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);

    }, [forceIsEditing]);


    return <>

        {isEditingField ? 

            <textarea type="text" value={value}
                ref={fieldRef}
                onBlur={() => { changeIsEditingField(false); }}
                onChange={(e) => changeValue(e.target.value)}
                style={{ width: "100%" }} maxLength="2000"></textarea>
            
            :

            <>
                <span
                    className={`editable-field-span`}
                    onClick={(e) => {
                            changeIsEditingField(true);
                        }
                    }
                >
                    {initialValue != "" ? initialValue : <ItemDetailsField_EmptyValue />}

                </span>
            </>

        }


    </>

}



const FieldType_CustomUserFieldEdit_SingleSelect = ({ field, globalContext, isAdd = false, forceIsEditing = null }) => {

    const fieldId = isAdd ? field.CustomFieldId : field.Id; // on Add the field id comes from globalContext.newItemCustomFields, on Edit comes from globalContext.currentItem.CustomFields
    const initialValue = isAdd ? "" : globalContext.currentItem.CustomFieldsAnswers?.find(item => item.CustomFieldId == fieldId)?.MultipleAnswers[0]?.DropdownId ?? "";
    let customFieldsAnswers;

    const [value, setValue] = useState(initialValue);
    const [options, setOptions] = useState([]);
    const [entityId, setEntityId] = useState(null);
    const [isEditingField, setIsEditingField] = useState(forceIsEditing != null ? forceIsEditing : isAdd ? true : false);


    useEffect(() => {

        if (isAdd) {
            setOptions(globalContext.newItemCustomFields?.find(item => item.CustomFieldId == fieldId)?.DropdownValues ?? []);
        }
        else {
            setOptions(globalContext.currentItem.CustomFields?.find(item => item.Id == fieldId)?.DropdownValues ?? []);
            setEntityId(globalContext.currentItem.Id);
        }

    }, []);



    const changeValue = (val) => {

        setValue(val);


        // Initialize


            if (isAdd)
                customFieldsAnswers = globalContext.newItemCustomFieldsAnswers;
            else
                customFieldsAnswers = globalContext.currentItem.CustomFieldsAnswers ?? [];


        // Process


            // Answer doesn't exist yet?
            if (!customFieldsAnswers.find(item => item.CustomFieldId == fieldId)) {
                customFieldsAnswers = _addCustomFieldsAnswersItem(customFieldsAnswers, fieldId, entityId);
            }

            let currentAnswerItem = customFieldsAnswers.find(item => item.CustomFieldId == fieldId);
            let currentAnswerArray = currentAnswerItem.MultipleAnswers;

            if (val == "")
                currentAnswerArray = [];
            else {
                let optionId = parseInt(val);
                let optionText = options.find(option => option.Id == val)?.DropdownValue ?? "";

                currentAnswerArray = [{ "Id": currentAnswerItem.CustomFieldId, "AnswerId": currentAnswerItem.Id, "DropdownId": optionId, "DropdownValue": optionText }];
            }
        

            customFieldsAnswers = customFieldsAnswers.map(item => item.CustomFieldId != fieldId ? item : { ...item, MultipleAnswers: currentAnswerArray });


        // Store


            if (isAdd) {
                globalContext.setNewItemCustomFieldsAnswers(customFieldsAnswers);
            }
            else {
                globalContext.setCurrentItem({
                    ...globalContext.currentItem,
                    CustomFieldsAnswers: customFieldsAnswers
                });
            }

    }



    
    const getIdealTextColor = (hexColor) => {

        if (!hexColor || hexColor == "")
            hexColor = "#ffffff";

        // Remove #
        const hex = hexColor.replace("#", "");

        // Convert hex to RGB
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        // Calculate perceived brightness
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;

        return brightness > 128 ? "#363636" : "#ffffff";
    };



    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);
    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);

    }, [forceIsEditing]);


    return <>

        

        {isEditingField ? 

            <select value={value} onChange={(e) => changeValue(e.target.value)} onBlur={() => changeIsEditingField(false)}>
                <option value=""></option>
                {options.map((option, index) => <option key={index} value={option.Id}>{option.DropdownValue}</option>)}
            </select>
            
            :

            <>
                <span
                    style={{
                        backgroundColor: value != "" ? options.find(item => item.Id == value)?.BackgroundColor : "",
                        color: getIdealTextColor(value != "" ? options.find(item => item.Id == value)?.BackgroundColor : ""),
                        padding: "3px 8px", borderRadius: "5px", textAlign: "center"
                    }}
                    className={`editable-field-span`}
                    onClick={(e) => {
                            changeIsEditingField(true);
                        }
                    }
                >
                    {value != "" ? options.find(item => item.Id == value)?.DropdownValue : <ItemDetailsField_EmptyValue />}

                </span>
            </>

        }




    </>

}



const FieldType_CustomUserFieldEdit_MultiSelect = ({ field, globalContext, isAdd = false, forceIsEditing = null }) => {

    const fieldId = isAdd ? field.CustomFieldId : field.Id; // on Add the field id comes from globalContext.newItemCustomFields, on Edit comes from globalContext.currentItem.CustomFields
    const initialValue = isAdd ? [] : globalContext.currentItem.CustomFieldsAnswers?.find(item => item.CustomFieldId == field.Id)?.MultipleAnswers ?? [];
    


    const [searchText, setSearchText] = useState("");
    const [filtered, setFiltered] = useState([]);
    const [selected, setSelected] = useState(initialValue);
    const [showFiltered, setShowFiltered] = useState(false);

    const [options, setOptions] = useState([]);
    const [entityId, setEntityId] = useState(null);
    const [isEditingField, setIsEditingField] = useState(forceIsEditing != null ? forceIsEditing : isAdd ? true : false);

    const popupRef = useRef(null);


    useEffect(() => {

        let initialOptions;

        if (isAdd) {
            initialOptions = globalContext.newItemCustomFields?.find(item => item.CustomFieldId == fieldId)?.DropdownValues ?? [];
        }
        else {
            initialOptions = globalContext.currentItem.CustomFields?.find(item => item.Id == fieldId)?.DropdownValues ?? [];
            setEntityId(globalContext.currentItem.Id);
        }

        setOptions(initialOptions);
        setFiltered(initialOptions);


    }, []);


    useClickOutside(popupRef, () => {
        setShowFiltered(false);
    });





    const search = (text) => {

        setSearchText(text);

        if (text == "")
            setFiltered(options);
        else
            setFiltered(options.filter(item => item.DropdownValue.includes(text)));
    }


    const showResultsDiv = () => {
        setShowFiltered(true);
    }


    const removeSelected = (dropdownId) => {

        let customFieldsAnswers;

        // Initialize


            if (isAdd)
                customFieldsAnswers = globalContext.newItemCustomFieldsAnswers;
            else
                customFieldsAnswers = globalContext.currentItem.CustomFieldsAnswers ?? [];


        // Process


        // Answer doesn't exist yet?
        if (!customFieldsAnswers.find(item => item.CustomFieldId == fieldId)) {
            customFieldsAnswers = _addCustomFieldsAnswersItem(customFieldsAnswers, fieldId, entityId);
        }

        let currentAnswerItem = customFieldsAnswers.find(item => item.CustomFieldId == fieldId);
        let currentAnswerArray = currentAnswerItem.MultipleAnswers;

        // Remove the item from the selected
        currentAnswerArray = currentAnswerArray.filter(item => item.DropdownId != dropdownId);
        
        customFieldsAnswers = customFieldsAnswers.map(item => item.CustomFieldId != fieldId ? item : { ...item, MultipleAnswers: currentAnswerArray });

        setSelected(currentAnswerArray);


        // Store


        if (isAdd) {
            globalContext.setNewItemCustomFieldsAnswers(customFieldsAnswers);
        }
        else {
            globalContext.setCurrentItem({
                ...globalContext.currentItem,
                CustomFieldsAnswers: customFieldsAnswers
            });
        }

    }


    const addSelected = (dropdownId) => {

        let customFieldsAnswers

        // Initialize


            if (isAdd)
                customFieldsAnswers = globalContext.newItemCustomFieldsAnswers;
            else
                customFieldsAnswers = globalContext.currentItem.CustomFieldsAnswers ?? [];


        // Process


            // Answer doesn't exist yet?
            if (!customFieldsAnswers.find(item => item.CustomFieldId == fieldId)) {
                customFieldsAnswers = _addCustomFieldsAnswersItem(customFieldsAnswers, fieldId, entityId);
            }

            let currentAnswerItem = customFieldsAnswers.find(item => item.CustomFieldId == fieldId);
            let currentAnswerArray = currentAnswerItem.MultipleAnswers;

            // Add the item to the selected
            if (!currentAnswerArray.find(item => item.DropdownId == dropdownId)) {

                let optionText = options.find(item => item.Id == dropdownId).DropdownValue;

                currentAnswerArray = [...currentAnswerArray, { Id: field.Id, AnswerId: currentAnswerItem.Id, DropdownId: dropdownId, DropdownValue: optionText }];

                customFieldsAnswers = customFieldsAnswers.map(item => item.CustomFieldId != fieldId ? item : { ...item, MultipleAnswers: currentAnswerArray });

                setSelected(currentAnswerArray);


                // Store


                if (isAdd) {
                    globalContext.setNewItemCustomFieldsAnswers(customFieldsAnswers);
                }
                else {
                    globalContext.setCurrentItem({
                        ...globalContext.currentItem,
                        CustomFieldsAnswers: customFieldsAnswers
                    });
                }
            }

    }


    const addRemoveSelected = (id, add) => {

        if (add)
            addSelected(id);
        else
            removeSelected(id);
    }



    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);
        
    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);

    }, [forceIsEditing]);


    return <>


        
        {isEditingField ? 
            
                <div style={{ display: "flex", flexDirection: "column", position: "relative" }}>

                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <div>
                            <input type="text" className="question-multiselect-search-input" placeholder="Search" value={searchText} onClick={() => showResultsDiv()} onChange={(e) => search(e.target.value)} />
                        </div>
                        {searchText != "" ? 
                            <div>
                                <div onClick={() => search("")} className="custom-question-multiselect-clear-search">×</div>
                            </div>
                        : null }
                    </div>


                    <div>
                        <div className="custom-question-multiselect-answers selected-tags">
                            {selected.map((item, index) => 
                                <span className="tag" key={index}>{item.DropdownValue}<button type="button" className="tag-remove" onClick={() => removeSelected(item.DropdownId)}>×</button></span>
                            )}
                        </div>
                    </div>


                    {showFiltered ? 
                        <div ref={popupRef} className="custom-question-multiselect-search-results" style={{display: "block", top: "60px"}}>
                            {filtered.map((item, index) => {

                                let isChecked = selected.find(s => s.DropdownId == item.Id) ? true : false;

                                return <div key={index}><label><input type="checkbox" checked={isChecked} onChange={(e) => addRemoveSelected(item.Id, e.target.checked)} /> {item.DropdownValue}</label></div>
                        
                            }
                            )}

                            {filtered.length == 0 ? <>No results...</> : null}
                        </div>
                    : null}

                </div>
            
            : 
            

            <>

                <div className={`editable-field-span`} onClick={() => changeIsEditingField(true)}>

                    {selected.length > 0 ?
                        <div>
                            <div className="custom-question-multiselect-answers selected-tags">
                                {selected.map((item, index) =>
                                    <span className="tag" key={index}>{item.DropdownValue}</span>
                                )}
                            </div>
                        </div>

                        :
                            <ItemDetailsField_EmptyValue />
                    }

                </div>

            </>


        }




    </>

}



const FieldType_CustomUserFieldEdit_Date = ({ field, globalContext, isAdd = false, forceIsEditing = null }) => {

    const fieldId = isAdd ? field.CustomFieldId : field.Id; // on Add the field id comes from globalContext.newItemCustomFields, on Edit comes from globalContext.currentItem.CustomFields
    const initialValue = isAdd ? "" : globalContext.currentItem.CustomFieldsAnswers?.find(item => item.CustomFieldId == fieldId)?.Value ?? "";

    const [value, setValue] = useState(initialValue);
    const [isEditingField, setIsEditingField] = useState(forceIsEditing != null ? forceIsEditing : isAdd ? true : false);

    let entityId = null;
    let customFieldsAnswers;


    const changeValue = (val) => {

        setValue(val);

        // Initialize

            if (isAdd) {
                customFieldsAnswers = globalContext.newItemCustomFieldsAnswers;
            }
            else {
                entityId = globalContext.currentItem.Id;
                customFieldsAnswers = globalContext.currentItem.CustomFieldsAnswers ?? [];
            }


        // Process


            // Answer doesn't exist yet?
            if (!customFieldsAnswers.find(item => item.CustomFieldId == fieldId)) {
                customFieldsAnswers = _addCustomFieldsAnswersItem(customFieldsAnswers, fieldId, entityId);
            }

            customFieldsAnswers = customFieldsAnswers.map(item => item.CustomFieldId != fieldId ? item : { ...item, Value: val });


        // Store

            if (isAdd) {
                globalContext.setNewItemCustomFieldsAnswers(customFieldsAnswers);
            }
            else {
                globalContext.setCurrentItem({
                    ...globalContext.currentItem,
                    CustomFieldsAnswers: customFieldsAnswers
                });
            }

    }


    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);
    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);

    }, [forceIsEditing]);

    return <>

        {isEditingField ?

            <input type="date" value={value} onChange={(e) => changeValue(e.target.value)} />
            :

            <>
                <div className={`editable-field-span`} onClick={() => changeIsEditingField(true)}>

                    {value ?
                        <span>{value}</span>
                        :
                        <ItemDetailsField_EmptyValue />
                    }

                </div>
            </>


        }

    </>

}


/**
 * 
 * This method creates the structure for a new response in the Custom Fields Answers object if there are no answers for the custom field yet
 */
const _addCustomFieldsAnswersItem = (customFieldsAnswers, customFieldId, entityId) => {

    let templateCustomFieldsAnswers = {
		"Id": 0,
		"CustomFieldId": customFieldId,
		"EntityId": String(entityId),
		"Value": null,
		"DropdownSelectedIds": null,
		"MultipleAnswers": [],
		"CreatedBy": 0,
		"CreatedDate": new Date(),
		"UpdatedBy": 0,
		"UpdatedDate": new Date(),
		"Deleted": 0
    };

    return [...customFieldsAnswers, templateCustomFieldsAnswers];

}



const FieldType_CountryWithFlag = ({ value }) => {

    return <><span style={{fontWeight: "500"} }>
        <img src={value.CountryFlag} style={{ height: "20px", marginRight: "5px" }} />
        {value.Country}</span>
    </>

}


const FieldType_ProductFamily = ({ value, globalContext }) => {

    let FamilyId = value.FamilyId;
    let FamilyName = value.FamilyName;

    return <>

        <a target="_blank" href={`${globalContext.productFamilyUrl}${FamilyId}`}>{FamilyName}</a>

    </>

}


const FieldType_ProductRegistrationsCount = ({ value, globalContext }) => {

    let ProductId = value.Id;
    let RegistrationsCount = value.RegistrationsCount;


    return <>

        <a target="_blank" href={`${globalContext.productRegistrationsCountUrl}${ProductId}`}>{RegistrationsCount}</a>

    </>

}


const ItemDetailsField_EmptyValue = () => {

    return <>
        <span style={{color: "#c0c0c0"}}>---</span>
    </>

}

const FieldType_ProductCode = ({ value }) => {

    let productCode = value.SKUProductCode;
    let archived = value.Archived;

    return <div style={{width: "100%", display: "flex", alignItems: "center"}}>
        <span style={{ fontWeight: 500, color: '#333' }}>{productCode}</span>
        {archived ? <span style={{marginLeft: "auto"}} className="u-label g-bg-gray-dark-v4 g-rounded-3">Archived</span> : null}
    </div>

}


const FieldType_ProductNameArchived = ({ value }) => {

    return <div style={{ width: "100%", display: "flex", alignItems: "center", gap: "8px" }}>
        <span>{value.ProductName}</span>
        {value.Archived ? <span className="u-label g-bg-gray-dark-v4 g-rounded-3">Archived</span> : null}
    </div>

}


// EU UDI version label, e.g. "Regulation device version 2"
const FieldType_UdiVersion = ({ value }) => {

    return <>{value.VersionLabel ?? value.Version ?? ""}</>

}


// Full regulation name
const FieldType_UdiRegulation = ({ value }) => {

    return <>{value.ApplicableRegulationName ?? value.ApplicableRegulation ?? ""}</>

}


const FieldType_ProductCountryOfOrigin = ({ value }) => {

    let CountryOfOrigin = value.CountryOfOrigin;
    let CountryOfOriginVal = value.CountryOfOriginVal;

    return <>{CountryOfOriginVal}</>
}


const FieldType_ProductMadeIn = ({ value }) => {

    let MadeIn = value.MadeIn;
    let MadeInVal = value.MadeInVal;

    return <>{MadeInVal}</>
}



const FieldType_ProductLegalManufacturers = ({ value }) => {


    return (<div>
        {value?.map((lm, index) => (

            <div className="operator-badges-container" key={index}>
                <a  className="operator-badge single"  href={`/your-medboard/country-registrations/certificates/view-operator/${lm.OperatorId}/`}>{lm.OperatorName}</a>
            </div>
        ))}
    </div>)

}


const FieldType_ProductPhysicalManufacturers = ({ value }) => {
    return <FieldType_ProductLegalManufacturers value={value} />;
};

const FieldType_ProductSPPP = ({ value }) => {
    return <FieldType_ProductLegalManufacturers value={value} />;
};



const FieldType_ProductCodeLink = ({ value }) => {

    let productId = value.ProductId;
    let productSKUCode = value.ProductSKUCode;
    let archived = value.Archived;

    return <>
            <a style={{ color: "#2b6cb0", fontWeight: "600" }} href={`/your-medboard/products/?productId=${productId}`}>{productSKUCode}</a>
            {archived ? 
                <span id="archiveTag" className="u-label g-bg-gray-dark-v4 g-rounded-3 g-ml-10">Archived</span>
            : null}
        </>

};



const FieldType_FamilyLink = ({ value }) => {

    let familyId = value.FamilyId;
    let familyName = value.FamilyName;

    if (!familyId)
        return <></>

    return <a href={`/your-medboard/product-families/?Id=${familyId}`}>{familyName}</a>

};


const FieldType_CountryRegistrationSelling = ({ value }) => {

    return <>
        {value == true ?  
            <span className="u-label g-bg-green g-rounded-3 g-mr-10">Yes</span>
        : 
            <span className="u-label g-bg-lightred g-rounded-3 g-mr-10">No</span>
        }
    </>

};


const FieldType_RegistrationsStatus = ({ value }) => {

    let statuses = [
        { id: 7, name: "Pre-Market Assessment", className: "g-bg-blue" },
        { id: 0, name: "New Registration Ongoing", className: "g-bg-blue" },
        { id: 6, name: "Registration Not Required", className: "g-bg-gray-light-v1" },
        { id: 1, name: "Active", className: "g-bg-green" },
        { id: 3, name: "Active - Renewing", className: "g-bg-green" },
        { id: 4, name: "Active - Modification", className: "g-bg-green" },
        { id: 5, name: "Suspended", className: "g-bg-lightred" },
        { id: 2, name: "Expired", className: "g-bg-lightred" },
        { id: 8, name: "Discontinued", className: "g-bg-black" },
        { id: 9, name: "Not Registered", className: "g-bg-orange" },
    ];

    let status = statuses.find(status => status.id == value) ?? null;

    return <>

        {status ? 
            <span className={`u-label ${status.className} g-rounded-3 g-mr-10`}>{status.name}</span>
            : null}

    </>


}



const FieldType_CertificateLink = ({ value }) => {

    let certificateId = value.CertificateId;
    let certificateName = value.CertificateName;
    let certificateDeleted = value.CertificateDeleted;

    return <>
        {certificateId ? (
            certificateDeleted ?
                <span>{certificateName} <span style={{ color: "#a0aec0" }}>(Deleted)</span></span>
            : <a href={`/your-medboard/country-registrations/certificates/view/${certificateId}/`}>{certificateName}</a>
        ) : null}
    </>

};



const FieldType_SubmissionLink = ({ value }) => {

    let submissionId = value.SubmissionId;
    let submissionTitle = value.SubmissionTitle;

    return <>
        {submissionId ?
            <a href={`/your-medboard/country-registrations/submissions/?submissionId=${submissionId}`}>{submissionTitle}</a>
        : null}
    </>

};



// Same shape as FieldType_CertificateLink/FieldType_SubmissionLink above — a real link, not a
// same-page filter callback. Points back at this same list with ?filter[CountryId]=<id>
// (SubmissionQAList.js reads that on load into defaultFilters, and DataTable.js's own
// "Submissions Q&A: <country>" heading — mirroring the countryregistrations one — picks up the
// same query param), matching how Registrations' own country links already work
// (FieldType_CountryLinkFilterRegistrations).
const FieldType_CountryLink = ({ value }) => {

    let countryId = value.CountryId;
    let countryName = value.CountryName;
    let flagLink = value.FlagLink;

    return <>
        {countryId ?
            <a href={`/your-medboard/country-registrations/registrations/?filter[CountryId]=${countryId}`}>
                <img className="countryFlag" src={flagLink} alt={`${countryName} flag`} style={{ height: "16px", marginRight: "5px", verticalAlign: "middle" }} />
                {countryName}
            </a>
        : null}
    </>

};




const FieldType_RiskClass = ({ value }) => {

    let options = [
        { Id: 0, Text: "I" },
        { Id: 1, Text: "Is" },
        { Id: 2, Text: "Im" },
        { Id: 3, Text: "II" },
        { Id: 4, Text: "IIa" },
        { Id: 5, Text: "IIb" },
        { Id: 6, Text: "III" },
        { Id: 7, Text: "IV" },
        { Id: 8, Text: "A" },
        { Id: 9, Text: "B" },
        { Id: 10, Text: "C" },
        { Id: 11, Text: "D" },
        { Id: 12, Text: "Unclassified" },
        { Id: 13, Text: "Other" },
    ];


    let option = options.find(op => op.Id == value) ?? null;

    return <>

        {option ? 
            <span className="category-badge-type">{option.Text}</span>
        : null}

    </>

}

const FieldType_MultipleOperators = ({ value = {}, operatorType }) => {
    let operators = [];
    let operatorsIds = [];

    if (operatorType === "importers") {
        operators = Array.isArray(value.Importers) ? value.Importers : [];
        operatorsIds = Array.isArray(value.ImportersIds) ? value.ImportersIds : [];
    } else if (operatorType === "representatives") {
        operators = Array.isArray(value.CountryRepresentatives) ? value.CountryRepresentatives : [];
        operatorsIds = Array.isArray(value.CountryRepresentativesIds) ? value.CountryRepresentativesIds : [];
    } else if (operatorType === "distributors") {
        operators = Array.isArray(value.CountryDistributors) ? value.CountryDistributors : [];
        operatorsIds = Array.isArray(value.CountryDistributorsIds) ? value.CountryDistributorsIds : [];
    }

    const matchedOperators = operators.filter((operator) =>
        operatorsIds.includes(operator.OperatorId)
    );



    return (
        <div className="operator-badges-container">
            {matchedOperators.map((operator) => (
                <a
                    key={operator.OperatorId}
                    className="operator-badge single"
                    href={`/your-medboard/country-registrations/operators/?operatorId=${operator.OperatorId}`}
                >
                    {operator.OperatorName}
                </a>
            ))}
        </div>
    );
};



const FieldType_MultipleOperatorsImporters = ({ value }) => {
    return <FieldType_MultipleOperators value={value} operatorType={"importers"} />
}
const FieldType_MultipleOperatorsRepresentatives = ({value}) => {
    return <FieldType_MultipleOperators value={value} operatorType={"representatives"} />
}
const FieldType_MultipleOperatorsDistributors = ({ value }) => {
    return <FieldType_MultipleOperators value={value} operatorType={"distributors"} />    
}


const FieldType_ListMultiRoles = ({ value }) => {

    value = value || [];

    const roles = [
        { Id: 1, Role: "Legal Manufacturer" },
        { Id: 2, Role: "Importer" },
        { Id: 3, Role: "Authorised Representative" },
        { Id: 4, Role: "Distributor" },
        { Id: 5, Role: "Physical Manufacturer" },
        { Id: 6, Role: "Reprocessor" },
        { Id: 7, Role: "Relabeler" },
        { Id: 8, Role: "Other" },
        { Id: 9, Role: "System or Procedure Pack Producer (SPPP)" },
    ];

    const selectedRoles = roles.filter(role => value.includes(role.Id));

    return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px"
        }}>
            {selectedRoles.map(role => (
                <div className="operator-badge-role" key={role.Id}>
                    {role.Role}
                </div>
            ))}
        </div>
    );
};



const FieldType_DateWithExpiredWarning = ({ value }) => {

    // convert it to UTC? otherwise just work with the date as is

    if (value && value.indexOf("Z") != -1)
        return <FieldType_DateWithExpiredWarningUTC value={value} />


    if (value == null || value === "")
        return "";

    const date = new Date(value);

    // Guard against Invalid Date objects
    if (isNaN(date.getTime())) {
        return <span>{value}</span>;
    }

    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    // Formatted to: dd mmm, yyyy (e.g., 07 Jul, 2026)
    const formattedDate = `${day} ${month}, ${year}`;

    const today = new Date();

    // remove time portion for accurate comparison
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    const isExpired = date < today;

    if (isExpired) {
        return (
            <span style={{ color: "#ec7784", fontWeight: 700 }}>
                {formattedDate}
            </span>
        );
    }

    return (
        <span>
            {formattedDate}
        </span>
    );
};





const FieldType_DateWithExpiredWarningUTC = ({ value }) => {
    if (value == null || value === "") {
        return "";
    }

    const date = new Date(value);

    // Guard against Invalid Date objects
    if (isNaN(date.getTime())) {
        return <span>{value}</span>;
    }

    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    const formattedDate = `${day} ${month}, ${year}`;

    const today = new Date();

    const todayUtc = Date.UTC(
        today.getUTCFullYear(),
        today.getUTCMonth(),
        today.getUTCDate()
    );

    const dateUtc = Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate()
    );

    const isExpired = dateUtc < todayUtc;

    return (
        <span
            style={
                isExpired
                    ? { color: "#ec7784", fontWeight: 700 }
                    : undefined
            }
        >
            {formattedDate}
        </span>
    );
};







const FieldType_RegistrationPriority = ({ value }) => {

    switch (parseInt(value)) {

        case 1:
            return (
                <span className="u-label g-bg-green g-rounded-3 g-mr-10">
                    Low
                </span>
            );

        case 2:
            return (
                <span className="u-label g-bg-yellow g-rounded-3 g-mr-10">
                    Medium
                </span>
            );

        case 3:
            return (
                <span className="u-label g-bg-lightred g-rounded-3 g-mr-10">
                    High
                </span>
            );

        case 0:
        default:
            return (
                <span className="u-label g-bg-gray-dark-v5 g-rounded-3 g-mr-10">
                    None
                </span>
            );
    }
};




const ItemDetailsField_Text = ({
    AppContext,
    field,
    fieldTitle,
    mandatory = false,
    forceIsEditing = null,
    richText = false,
    isNumeric = false,
    isTextarea = false,
    displayFieldOnly = false,
    minLength = null,
    maxLength = null,
    validationRegex = null,
    userReadableFormat = "",
    placeholder = "",
    allowImages = true,
}) => {

    const [errorVar, setErrorVar] = useState(null);

    const [isEditingField, setIsEditingField] = useState(
        forceIsEditing != null ? forceIsEditing : false
    );

    const fieldRef = useRef(null);
    const trumbowygRef = useRef(null);

    const validate = () => {

        const value = AppContext.currentItem[field];
        const textValue = value ?? "";

        let hasError = null;

        // Mandatory validation
        if (
            mandatory &&
            (
                value == null ||
                value === "" ||
                value === "<p><br></p>"
            )
        ) {
            hasError = 1;
        }

        // Only validate plain text fields
        if (!richText && !hasError) {

            if (
                minLength != null &&
                textValue.length < minLength
            ) {
                hasError = 2;
            }

            if (
                maxLength != null &&
                textValue.length > maxLength
            ) {
                hasError = 3;
            }

            if (
                validationRegex != null &&
                textValue.length > 0 &&
                !validationRegex.test(textValue)
            ) {
                hasError = 4;
            }
        }

        setErrorVar(hasError);
    };

    // Validate mandatory status
    useEffect(() => {

        validate();

    }, [AppContext.currentItem]);



    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);

        setTimeout(() => {

            if (
                !richText &&
                !isTextarea &&
                fieldRef.current
            ) {

                fieldRef.current.selectionStart = 0;
                fieldRef.current.selectionEnd = 0;

            }

        }, 10);
    };


    // Sync force editing state
    useEffect(() => {

        if (forceIsEditing != null) {

            setIsEditingField(forceIsEditing);

        }

    }, [forceIsEditing]);





    // Initialize Trumbowyg
    useEffect(() => {

        const initEditor = async () => {

            if (
                richText &&
                isEditingField &&
                trumbowygRef.current
            ) {

                // Make jQuery global
                window.$ = $;
                window.jQuery = $;

                // Dynamically import trumbowyg
                await import("trumbowyg");

                const $editor = $(trumbowygRef.current);

                if (!$editor.data("trumbowyg")) {

                    $editor.trumbowyg({

                        btns: [
                            ["viewHTML"],
                            ["formatting"],
                            ["strong", "em", "del"],
                            ["superscript", "subscript"],
                            ["link"],
                            ...(allowImages ? [["insertImage"]] : []),
                            ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
                            ["unorderedList", "orderedList"],
                            ["horizontalRule"],
                            ["removeformat"],
                            ["fullscreen"]
                        ],

                        autogrow: true

                    });





                    $editor.trumbowyg(
                        "html",
                        AppContext.currentItem[field] || ""
                    );







                    const editorElement = $editor.parent().find(".trumbowyg-editor");

                    editorElement.off("paste.notesImageUpload");

                    editorElement.on(
                        "paste.notesImageUpload",
                        async (e) => {

                            e.preventDefault();

                            const clipboardData = e.originalEvent.clipboardData;

                            if (!clipboardData?.items)
                                return;

                            const items = [...clipboardData.items];

                            const imageItems = allowImages ? items.filter(
                                item => item.type.startsWith("image/")
                            ) : [];

                            const htmlItem = items.find(
                                item => item.type === "text/html"
                            );

                            let htmlContent = "";
                            let embeddedImages = [];
                            let doc = null;

                            if (htmlItem) {

                                htmlContent = await new Promise(
                                    resolve => htmlItem.getAsString(resolve)
                                );

                                const parser = new DOMParser();

                                doc = parser.parseFromString(
                                    htmlContent,
                                    "text/html"
                                );

                                if (allowImages) {

                                    embeddedImages = [...doc.querySelectorAll("img")]
                                        .filter(img =>
                                            img.src.startsWith("data:image")
                                        );

                                } else {

                                    // This field only accepts text — drop any images
                                    // instead of embedding/uploading them.
                                    doc.querySelectorAll("img").forEach(
                                        img => img.remove()
                                    );

                                    htmlContent = doc.body.innerHTML;

                                }

                            }



                            if (imageItems.length === 0 &&
                                embeddedImages.length === 0) {

                                // If rich HTML exists (Word, Gmail, websites, etc.)
                                if (htmlContent) {

                                    $editor.trumbowyg(
                                        "execCmd",
                                        {
                                            cmd: "insertHTML",
                                            param: htmlContent
                                        }
                                    );

                                } else {

                                    // Fallback to plain text
                                    const text = clipboardData.getData("text/plain");

                                    $editor.trumbowyg(
                                        "execCmd",
                                        {
                                            cmd: "insertText",
                                            param: text
                                        }
                                    );

                                }

                                return;
                            }



                            e.preventDefault();

                            const placeholders = [];

                            const batchId = Date.now();

                            embeddedImages.forEach((img, index) => {

                                const placeholderId = `upload-${batchId}-${index}`;

                                placeholders.push({
                                    id: placeholderId,
                                    base64: img.src
                                });

                                img.src = "/assets/js/frontend/public/loading-spinner.gif";

                                img.setAttribute("style", "width:auto; height:auto; display:block; margin:10px 0;");

                                img.setAttribute("data-upload-id", placeholderId);

                            });

                            // Rebuild HTML from the modified DOM
                            // Only rebuild if a document exists
                            if (doc) {
                                htmlContent = doc.body.innerHTML;
                            }




                            if (!htmlContent && imageItems.length > 0) {

                                imageItems.forEach((item, index) => {

                                    const placeholderId = `upload-${Date.now()}-${index}`;

                                    placeholders.push({
                                        id: placeholderId,
                                        file: item.getAsFile()
                                    });

                                    htmlContent += `
                                        <img
                                            data-upload-id="${placeholderId}"
                                            src="/assets/js/frontend/public/loading-spinner.gif"
                                            style="width:auto; height:auto; display:block; margin:10px 0;"
                                        />
                                    `;

                                });

                            }

                            $editor.trumbowyg(
                                "execCmd",
                                {
                                    cmd: "insertHTML",
                                    param: htmlContent
                                }
                            );

                            const editorElement = $editor
                                .parent()
                                .find(".trumbowyg-editor");

                            try {

                                await Promise.all(

                                    placeholders.map(async (p, i) => {

                                        let base64 = p.base64;

                                        if (!base64) {

                                            base64 = await new Promise(
                                                (resolve, reject) => {

                                                    const reader = new FileReader();

                                                    reader.onload = () => resolve(reader.result);

                                                    reader.onerror = reject;

                                                    reader.readAsDataURL(p.file);

                                                }
                                            );

                                        }

                                        const response = await fetch(
                                            "/umbraco/api/Images/Image",
                                            {
                                                method: "POST",
                                                headers: {
                                                    "Content-Type": "application/json"
                                                },
                                                body: JSON.stringify({
                                                    entityType: AppContext.entityType,
                                                    imageBase64: base64
                                                })
                                            }
                                        );


                                        if (!response.ok)
                                            throw new Error("Upload failed");


                                        let imageUrl = await response.text();

                                        imageUrl = "/umbraco/api/Images/Image/?id=" + imageUrl + "&entityType=" + AppContext.entityType;

                                        editorElement.find(
                                            `[data-upload-id="${p.id}"]`
                                        )
                                            .attr("src", imageUrl)
                                            .removeAttr("data-upload-id")
                                            .css({
                                                width: "auto",
                                                height: "auto",
                                                maxWidth: "100%"
                                            });

                                    })

                                );

                                const html = editorElement.html();

                                AppContext.setCurrentItem({
                                    ...AppContext.currentItem,
                                    [field]: html
                                });

                            }
                            catch (err) {

                                console.error(err);

                            }


                            return () => {
                                if (richText && trumbowygRef.current) {
                                    const $editor = $(trumbowygRef.current);

                                    $editor
                                        .parent()
                                        .find(".trumbowyg-editor")
                                        .off("paste.notesImageUpload");

                                    if ($editor.data("trumbowyg")) {
                                        $editor.trumbowyg("destroy");
                                    }
                                }
                            };

                        }
                    );







                    $editor.on("tbwchange tbwblur", () => {

                        const editorElement = $editor
                                .parent()
                                .find(".trumbowyg-editor");

                        const html = editorElement.html();

                        AppContext.setCurrentItem({
                            ...AppContext.currentItem,
                            [field]: html
                        });

                    });
                }
            }
        };

        initEditor();

        return () => {

            if (
                richText &&
                trumbowygRef.current
            ) {

                const $editor = $(trumbowygRef.current);

                if ($editor.data("trumbowyg")) {

                    $editor.trumbowyg("destroy");

                }
            }
        };

    }, [isEditingField, richText]);




    // Keep rich text editor synced
    useEffect(() => {

        if (
            richText &&
            trumbowygRef.current
        ) {

            const $editor = $(trumbowygRef.current);

            if ($editor.data("trumbowyg")) {

                const currentHtml = $editor.trumbowyg("html");
                const newHtml = AppContext.currentItem[field] || "";

                if (currentHtml !== newHtml) {

                    $editor.trumbowyg("html", newHtml);

                }
            }
        }

    }, [AppContext.currentItem[field]]);



    const fieldContent = (

        <div className="view-task-field-value">

            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    width: "100%"
                }}
            >

                <div style={{ width: "100%" }}>

                    {isEditingField === false ? (

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                width: "100%"
                            }}
                        >

                            <span
                                className={`editable-field-span ${errorVar ? "form-field-error" : ""}`}
                                onClick={() => {
                                    changeIsEditingField(true);
                                }}
                            >

                                {
                                    AppContext.currentItem[field] &&
                                        (
                                            AppContext.currentItem[field].length > 0 ||
                                            isNumeric === true
                                        )

                                        ? (

                                            richText ? (

                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: AppContext.currentItem[field]
                                                    }}
                                                />

                                            ) : (

                                                AppContext.currentItem[field]

                                            )

                                        ) : (

                                            <ItemDetailsField_EmptyValue />

                                        )
                                }

                            </span>

                        </div>

                    ) : (

                        <span style={{ width: "100%" }}>

                            {richText ? (

                                <div
                                    ref={trumbowygRef}
                                    style={{
                                        width: "100%",
                                        height: "300px",
                                        backgroundColor: "white"
                                    }}
                                />

                            ) : (

                                <>
                                    {isTextarea ? (

                                        <textarea
                                            ref={fieldRef}
                                            style={{
                                                width: "100%",
                                                minHeight: "120px",
                                                resize: "vertical"
                                            }}
                                            autoFocus={
                                                forceIsEditing != null
                                                    ? false
                                                    : true
                                            }
                                            onBlur={() => {

                                                changeIsEditingField(false);

                                            }}
                                            onChange={(e) => {

                                                let value = e.target.value;

                                                if (isNumeric) {

                                                    value = value.replace(
                                                        /[^0-9]/g,
                                                        ""
                                                    );

                                                }

                                                AppContext.setCurrentItem({
                                                    ...AppContext.currentItem,
                                                    [field]: value
                                                });

                                            }}
                                            value={
                                                AppContext.currentItem[field] || ""
                                            }
                                        />

                                    ) : (

                                        <input
                                            ref={fieldRef}
                                            style={{ width: "100%" }}
                                            placeholder={placeholder}
                                            autoFocus={
                                                forceIsEditing != null
                                                    ? false
                                                    : true
                                            }
                                            onBlur={() => {

                                                changeIsEditingField(false);

                                            }}
                                            onChange={(e) => {

                                                let value = e.target.value;

                                                if (isNumeric) {

                                                    value = value.replace(
                                                        /[^0-9]/g,
                                                        ""
                                                    );

                                                }

                                                AppContext.setCurrentItem({
                                                    ...AppContext.currentItem,
                                                    [field]: value
                                                });

                                            }}
                                            value={
                                                AppContext.currentItem[field] || ""
                                            }
                                        />

                                    )}
                                </>

                            )}

                        </span>

                    )}

                </div>

                <div>

                    {errorVar && (

                        <span className="form-field-error-message">

                            {errorVar == 1 ? <>
                                The field {fieldTitle} is necessary
                            </> : null}

                            {errorVar == 2 ? <>
                                The field {fieldTitle} requires minimum {minLength} characters
                            </> : null}

                            {errorVar == 3 ? <>
                                The field {fieldTitle} requires maximum {maxLength} characters
                            </> : null}

                            {errorVar == 4 ? <>
                                The field {fieldTitle} doesn't maatch the correct format: {userReadableFormat}
                            </> : null}


                        </span>

                    )}

                </div>

            </div>

        </div>

    );

    return displayFieldOnly ? (
        fieldContent
    ) : (
        <div className="view-task-field">

            <div className="view-task-field-line">

                <div className="view-task-field-title">
                    {fieldTitle}
                </div>

                {fieldContent}

            </div>

        </div>
    );


};


const ItemDetailsField_Dropdown = ({
    AppContext,
    fieldTitle,
    fieldId,
    fieldName,
    LOV,
    LOVIdField,
    LOVNameField,
    mandatory = false,
    addEmptyIfNotMandatory = true,
    defaultEmptyId = "",
    defaultEmptyText = "",
    link = null,
    forceIsEditing = null,
    enableSearch = false,
    renderWith = null,
    displayFieldOnly = false,
}) => {

    const [errorVar, setErrorVar] = useState(false);
    const [isEditingField, setIsEditingField] = useState(
        forceIsEditing != null ? forceIsEditing : false
    );

    const [finalLink, setFinalLink] = useState(null);

    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    if (!mandatory && addEmptyIfNotMandatory) {
        LOV = [
            {
                [LOVIdField]: defaultEmptyId,
                [LOVNameField]: defaultEmptyText
            },
            ...LOV
        ];
    }

    const filteredLOV = enableSearch
        ? LOV.filter(item =>
            (item?.[LOVNameField] || "")
                .toLowerCase()
                .includes(search.toLowerCase())
        )
        : LOV;

    useEffect(() => {

        if (
            link &&
            AppContext.currentItem[fieldId] != null &&
            AppContext.currentItem[fieldId] != defaultEmptyId
        ) {
            changeFinalLink(AppContext.currentItem[fieldId]);
        }

    }, []);

    const validate = () => {

        if (
            mandatory &&
            (
                AppContext.currentItem[fieldId] == null ||
                AppContext.currentItem[fieldId] == defaultEmptyId
            )
        ) {
            setErrorVar(true);
        }
        else {
            setErrorVar(false);
        }

    };

    const changeFinalLink = (val) => {

        let tmp = link;

        if (val == defaultEmptyId) {
            setFinalLink(null);
        }
        else {
            tmp = tmp.replaceAll("[PARAM]", val);
            setFinalLink(tmp);
        }

    };

    const handleChange = (value, text) => {

        AppContext.setCurrentItem({
            ...AppContext.currentItem,
            [fieldId]: value,
            [fieldName]: text
        });

        if (link)
            changeFinalLink(value);

        setIsOpen(false);
        setSearch(text);

        changeIsEditingField(false);

    };

    useEffect(() => {
        validate();
    }, [AppContext.currentItem]);

    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);

    };

    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);

    }, [forceIsEditing]);


    const fieldContent = (

        <div className="view-task-field-value">

            {/* ================= VIEW MODE ================= */}
            {isEditingField === false ? (

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start"
                    }}
                >

                    <span
                        className={`editable-field-span ${errorVar ? "form-field-error" : ""}`}
                        onClick={() => {
                            changeIsEditingField(true);
                            setSearch("");
                        }}
                    >

                        {AppContext.currentItem[fieldId] == defaultEmptyId ? ( // Changed to == for safe comparison

                            <ItemDetailsField_EmptyValue />

                        ) : (

                            (() => {
                             
                                const displayValue =
                                    LOV.find(
                                        item =>
                                            String(item[LOVIdField]) === String(AppContext.currentItem[fieldId])
                                    )?.[LOVNameField];

                                if (displayValue == null)
                                    return <ItemDetailsField_EmptyValue />;

                                if (renderWith) {

                                    const RenderComponent = renderWith;

                                    return (
                                        <RenderComponent
                                            object={AppContext.currentItem[fieldId]}
                                        />
                                    );

                                }

                                return finalLink ? (

                                    <a
                                        href={finalLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {displayValue}
                                    </a>

                                ) : (

                                    displayValue

                                );

                            })()

                        )}

                    </span>

                    {errorVar && (

                        <span className="form-field-error-message">
                            The field {fieldTitle} is necessary
                        </span>

                    )}

                </div>

            ) : enableSearch ? (

                /* ================= SEARCHABLE DROPDOWN ================= */
                <div
                    style={{
                        position: "relative",
                        width: "100%"
                    }}
                >

                    <input
                        type="text"
                        value={
                            isOpen
                                ? search
                                : (
                                    
                                    LOV.find(
                                        i => String(i[LOVIdField]) === String(AppContext.currentItem[fieldId])
                                    )?.[LOVNameField] || ""
                                )
                        }
                        placeholder={`Select ${fieldTitle}`}
                        onFocus={() => {
                            setIsOpen(true);
                            setSearch("");
                        }}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setIsOpen(true);
                        }}
                        onBlur={() => {
                            setTimeout(() => {
                                setIsOpen(false);
                            }, 150);

                            changeIsEditingField(false);
                        }}
                        style={{
                            width: "100%",
                            padding: "6px",
                            paddingRight: "32px",
                            borderRadius: "4px",
                            border: "1px solid #ccc"
                        }}
                    />

                    {(AppContext.currentItem[fieldId] || search) && !mandatory && (

                        <button
                            type="button"
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={() => {

                                AppContext.setCurrentItem({
                                    ...AppContext.currentItem,
                                    [fieldId]: defaultEmptyId,
                                    [fieldName]: defaultEmptyText
                                });

                                if (link)
                                    changeFinalLink(defaultEmptyId);

                                setSearch("");
                                setIsOpen(false);

                                changeIsEditingField(false);

                            }}
                            style={{
                                position: "absolute",
                                right: "8px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                                fontSize: "16px",
                                color: "#888",
                                padding: 0,
                                lineHeight: 1
                            }}
                        >
                            ×
                        </button>

                    )}

                    {isOpen && (

                        <div
                            style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                maxHeight: "200px",
                                overflowY: "auto",
                                background: "#fff",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                zIndex: 1000
                            }}
                        >

                            {filteredLOV.length > 0 ? (

                                filteredLOV.map(item => (

                                    <div
                                        key={item[LOVIdField]}
                                        onMouseDown={(e) =>
                                            e.preventDefault()
                                        }
                                        onClick={() =>
                                            handleChange(
                                                item[LOVIdField],
                                                item[LOVNameField]
                                            )
                                        }
                                        style={{
                                            padding: "6px",
                                            cursor: "pointer"
                                        }}
                                    >

                                        {item[LOVNameField]}

                                    </div>

                                ))

                            ) : (

                                <div
                                    style={{
                                        padding: "6px",
                                        color: "#888"
                                    }}
                                >
                                    No results
                                </div>

                            )}

                        </div>

                    )}

                </div>

            ) : (

                /* ================= NORMAL SELECT ================= */
                <select
                    style={{ maxWidth: "100%" }}
                    value={AppContext.currentItem[fieldId]}
                    onBlur={() => changeIsEditingField(false)}
                    onChange={(e) => {

                        const selectedOption =
                            e.target.selectedOptions[0];

                        AppContext.setCurrentItem({
                            ...AppContext.currentItem,
                            [fieldId]: e.target.value,
                            [fieldName]: selectedOption.text
                        });

                        if (link)
                            changeFinalLink(e.target.value);

                    }}
                >

                    {LOV.map(item => (

                        <option
                            key={item[LOVIdField]}
                            value={item[LOVIdField]}
                        >

                            {item[LOVNameField]}

                        </option>

                    ))}

                </select>

            )}

        </div>

    );

    return displayFieldOnly ? (
        <>
            {fieldContent}
        </>
    ) : (
        <div className="view-task-field">

            <div className="view-task-field-line">

                <div className="view-task-field-title">
                    {fieldTitle}
                </div>

                {fieldContent}

            </div>

        </div>
    );

};



const ItemDetailsField_MultiSelect = ({
    AppContext,
    fieldTitle,
    fieldId,
    fieldName,
    selectedItems = [],
    LOV = [],
    LOVIdField,
    LOVNameField,
    mandatory = false,
    noneIsAll = true,
    itemLink = null,
    forceIsEditing = null,
    displayFieldOnly = false,
    allowAddOperator = false,
    operatorRoleId = null,
    onRefreshOperators = null
}) => {

    const [formState, setFormState] = useState({});
    const [isEditingField, setIsEditingField] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [searchValues, setSearchValues] = useState({});
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [possibleValuesObject, setPossibleValuesObject] = useState({});

    const dropdownRefs = useRef({});

    useEffect(() => {
        const initialState = {};

        initialState[fieldName] = selectedItems;

        setFormState(initialState);

    }, []);

    useEffect(() => {

        setPossibleValuesObject({
            Alias: fieldName,
            Name: "",
            Items: (LOV ?? []).map(pv => ({
                Text: pv[LOVNameField],
                Value: pv[LOVIdField],
                Disabled: false,
                Group: null,
                Selected: false
            }))
        });

    }, [LOV, fieldName, LOVIdField, LOVNameField]);



    useEffect(() => {

        AppContext.setCurrentItem({ ...AppContext.currentItem, [fieldName]: formState[fieldName] });

    }, [formState]);


    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);

    }, [forceIsEditing]);




    const fieldContent = (

        <div className="view-task-field-value">

            <div style={{ width: "100%", position: "relative" }}>

                {isEditingField === false ? (

                    <>
                        {selectedItems.length == 0 ? (
                            <span
                                className="editable-field-span"
                                onClick={() => changeIsEditingField(true)}
                            >
                                <ItemDetailsField_EmptyValue />
                            </span>
                        ) : (
                            <div className="selected-tags">

                                {LOV
                                    .filter(item =>
                                        selectedItems.includes(item[LOVIdField])
                                    )
                                    .map((item, index) => (
                                        <span key={index} className="tag">

                                            {itemLink ? (
                                                <a
                                                    href={itemLink.replaceAll(
                                                        "[PARAM]",
                                                        item[LOVIdField]
                                                    )}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {item[LOVNameField]}
                                                </a>
                                            ) : (
                                                <span>{item[LOVNameField]}</span>
                                            )}

                                        </span>
                                    ))}

                            </div>
                        )}
                    </>

                ) : (

                    <MultiSelectField
                        field={possibleValuesObject}
                        formState={formState}
                        setFormState={setFormState}
                        fieldsConfig={[possibleValuesObject]}
                        searchValues={searchValues}
                        setSearchValues={setSearchValues}
                        activeDropdown={activeDropdown}
                        setActiveDropdown={setActiveDropdown}
                        dropdownRefs={dropdownRefs}
                        noneIsAll={noneIsAll}
                        itemLink={itemLink}
                        allowAddOperator={allowAddOperator}
                        operatorRoleId={operatorRoleId}
                        onRefreshOperators={onRefreshOperators}
                    />

                )}

            </div>

        </div>

    );



    return displayFieldOnly ? (
        fieldContent
    ) : (
        <div className="view-task-field">

            <div className="view-task-field-line">

                <div className="view-task-field-title">
                    {fieldTitle}
                </div>

                {fieldContent}

            </div>

        </div>
    );

}







const ItemDetailsField_Image = ({
    AppContext,
    fieldTitle,
    urlFieldName,
    fieldName,
    fieldRemoveStatus = null,
    forceIsEditing = null,
    displayFieldOnly = false, // NEW
}) => {

    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [isEditing, setIsEditing] = useState(
        forceIsEditing != null ? forceIsEditing : false
    );
    const [imageVersion, setImageVersion] = useState(Date.now());

    const fileInputRef = useRef(null);

    const handleRemoveImage = () => {
        setFile(null);
        setPreview(null);

        let updatedItem = {
            ...AppContext.currentItem,
            [fieldName]: null,
            [urlFieldName]: null
        };

        if (fieldRemoveStatus)
            updatedItem = {
                ...updatedItem,
                [fieldRemoveStatus]: true
            };

        AppContext.setCurrentItem(updatedItem);

        if (fileInputRef.current)
            fileInputRef.current.value = "";

        setImageVersion(Date.now());
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];

        if (!selectedFile) {
            AppContext.setCurrentItem({
                ...AppContext.currentItem,
                [fieldName]: null,
                [fieldRemoveStatus]: true
            });
            return;
        }

        setFile(selectedFile);

        AppContext.setCurrentItem({
            ...AppContext.currentItem,
            [fieldName]: selectedFile,
            [fieldRemoveStatus]: true,
            [urlFieldName]: null
        });

        const previewUrl = URL.createObjectURL(selectedFile);
        setPreview(previewUrl);

        setImageVersion(Date.now());
    };

    useEffect(() => {
        if (forceIsEditing != null)
            setIsEditing(forceIsEditing);
    }, [forceIsEditing]);

    useEffect(() => {
        setFile(null);
        setPreview(null);
    }, [forceIsEditing]);

    useEffect(() => {
        if (
            AppContext.currentItem &&
            AppContext.currentItem[urlFieldName]
        ) {
            setFile(null);
            setPreview(null);
            setImageVersion(Date.now());
        }
    }, [AppContext.currentItem?.[urlFieldName]]);

    const displayImageSrc =
        isEditing
            ? (
                preview ||
                AppContext.currentItem[urlFieldName]
            )
                ? `${AppContext.currentItem[urlFieldName]}&t=${imageVersion}`
                : null
            : AppContext.currentItem[urlFieldName]
                ? `${AppContext.currentItem[urlFieldName]}&t=${imageVersion}`
                : null;

    // NEW: extract body
    const fieldContent = (
        <div className="view-task-field-value">
            <div style={{ display: "flex", flexDirection: "column" }}>

                {isEditing ? (
                    <>
                        {!file && (
                            <>
                                {AppContext.currentItem[urlFieldName] ? (
                                    <div style={{ minHeight: "200px" }}>
                                        <img
                                            src={`${AppContext.currentItem[urlFieldName]}&t=${imageVersion}`}
                                            style={{ maxHeight: 200, marginTop: 10 }}
                                            alt="Current"
                                        />
                                    </div>
                                ) : (
                                    <div>
                                        <input
                                            ref={fileInputRef}
                                            id={`imageUpload-${fieldName}`}
                                            type="file"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                            style={{ display: "none" }}
                                        />

                                        <label
                                            htmlFor={`imageUpload-${fieldName}`}
                                            className="image-upload-button"
                                        >
                                            Choose Image
                                        </label>
                                    </div>
                                )}
                            </>
                        )}

                        {preview && (
                            <div style={{ minHeight: "200px" }}>
                                <img
                                    src={preview}
                                    alt="preview"
                                    style={{
                                        maxHeight: 200,
                                        marginTop: 10
                                    }}
                                />
                            </div>
                        )}

                        {(file || AppContext.currentItem[urlFieldName]) && (
                            <div>
                                <button
                                    type="button"
                                    className="image-remove-button"
                                    onClick={handleRemoveImage}
                                    style={{ marginTop: 10 }}
                                >
                                    Remove Image
                                </button>
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        {displayImageSrc ? (
                            <div style={{ minHeight: "200px" }}>
                                <img
                                    src={displayImageSrc}
                                    style={{ maxWidth: "250px" }}
                                    alt="Saved or preview"
                                />
                            </div>
                        ) : (

                            <div style={{textAlign: "center"}}>
                                <i style={{fontSize: "40px"}} className="far fa-image"></i>
                                <br/>
                                <span>No image</span>
                            </div>
                                    
                        )}
                    </>
                )}

            </div>
        </div>
    );

    // NEW: conditional render
    return displayFieldOnly ? (
        <>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                {fieldContent}
            </div>
        </>
    ) : (
        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">
                    {fieldTitle}
                </div>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {fieldContent}
                </div>
            </div>
        </div>
    );
};





const ItemDetailsField_Date = ({
    AppContext,
    field,
    fieldTitle,
    mandatory = false,
    forceIsEditing = null,
    warning = false,
    displayFieldOnly = false
}) => {
    const [errorVar, setErrorVar] = useState(false);
    const [isEditingField, setIsEditingField] = useState(
        forceIsEditing != null ? forceIsEditing : false
    );

    const fieldRef = useRef(null);

    const validate = () => {
        if (
            mandatory &&
            (AppContext.currentItem[field] == null ||
                AppContext.currentItem[field] === "")
        )
            setErrorVar(true);
        else
            setErrorVar(false);
    };

    // Validate mandatory status
    useEffect(() => {
        validate();
    }, [AppContext.currentItem]);

    const changeIsEditingField = (state) => {
        if (forceIsEditing != null) return;

        setIsEditingField(state);

        setTimeout(() => {
            if (fieldRef.current)
                fieldRef.current.showPicker?.();
        }, 10);
    };

    useEffect(() => {
        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);
    }, [forceIsEditing]);

    const formatDate = (dateString) => {
        if (!dateString) return null;

        try {
            const date = new Date(dateString);

            // Guard against Invalid Date objects
            if (isNaN(date.getTime())) {
                return dateString;
            }

            const day = String(date.getDate()).padStart(2, '0');
            const monthNames = [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];
            const month = monthNames[date.getMonth()];
            const year = date.getFullYear();

            // Returns format: dd mmm, yyyy (e.g., 07 Jul, 2026)
            return `${day} ${month}, ${year}`;

        } catch {
            return dateString;
        }
    };

    const dateOnly = (date) => {
        if (!date) return null;
        return date.split("T")[0];
    };

   
    let isExpired = false;
    if (warning && AppContext.currentItem[field]) {
        const date = new Date(AppContext.currentItem[field]);
        if (!isNaN(date.getTime())) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            date.setHours(0, 0, 0, 0);
            isExpired = date < today;
        }
    }

    const fieldContent = (
        <div className="view-task-field-value">
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start"
                }}
            >
                <div>
                    {isEditingField === false ? (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start"
                            }}
                        >
                            <span
                                className={`editable-field-span ${errorVar ? "form-field-error" : ""
                                    }`}
                                style={
                                    isExpired
                                        ? { color: "#ec7784", fontWeight: 700 }
                                        : {}
                                }
                                onClick={() => {
                                    changeIsEditingField(true);
                                }}
                            >
                                {AppContext.currentItem[field] ? (
                                    formatDate(AppContext.currentItem[field])
                                ) : (
                                    <ItemDetailsField_EmptyValue />
                                )}
                            </span>
                        </div>
                    ) : (
                        <span style={{ width: "100%" }}>
                            <input
                                ref={fieldRef}
                                type="date"
                                style={{ width: "100%" }}
                                autoFocus={forceIsEditing != null ? false : true}
                                onBlur={() => {
                                    changeIsEditingField(false);
                                }}
                                onChange={(e) =>
                                    AppContext.setCurrentItem({
                                        ...AppContext.currentItem,
                                        [field]: e.target.value
                                    })
                                }
                                value={
                                    dateOnly(AppContext.currentItem[field]) || ""
                                }
                            />
                        </span>
                    )}
                </div>

                <div>
                    {errorVar && (
                        <span className="form-field-error-message">
                            The field {fieldTitle} is necessary
                        </span>
                    )}
                </div>
            </div>
        </div>
    );

    return !displayFieldOnly ? fieldContent : <>{fieldContent}</>;
};


const ItemDetailsField_DateUTC = ({
    AppContext,
    field,
    fieldTitle,
    mandatory = false,
    forceIsEditing = null,
    warning = false,
    displayFieldOnly = false
}) => {
    const [errorVar, setErrorVar] = useState(false);
    const [isEditingField, setIsEditingField] = useState(
        forceIsEditing != null ? forceIsEditing : false
    );

    const fieldRef = useRef(null);

    const validate = () => {
        if (
            mandatory &&
            (AppContext.currentItem[field] == null ||
                AppContext.currentItem[field] === "")
        ) {
            setErrorVar(true);
        } else {
            setErrorVar(false);
        }
    };

    useEffect(() => {
        validate();
    }, [AppContext.currentItem]);

    const changeIsEditingField = (state) => {
        if (forceIsEditing != null) return;

        setIsEditingField(state);

        setTimeout(() => {
            if (fieldRef.current) {
                fieldRef.current.showPicker?.();
            }
        }, 10);
    };

    useEffect(() => {
        if (forceIsEditing != null) {
            setIsEditingField(forceIsEditing);
        }
    }, [forceIsEditing]);

    const formatDate = (dateString) => {
        if (!dateString) return null;

        try {
            const date = new Date(dateString);

            if (isNaN(date.getTime())) {
                return dateString;
            }

            const monthNames = [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];

            const day = String(date.getUTCDate()).padStart(2, "0");
            const month = monthNames[date.getUTCMonth()];
            const year = date.getUTCFullYear();

            return `${day} ${month}, ${year}`;
        } catch {
            return dateString;
        }
    };

    const dateOnly = (date) => {

        if (!date) return "";

        let result = "";
        try {
            result = new Date(date).toISOString().slice(0, 10);
        }
        catch (ex) {
        }

        return result;
    };

    let isExpired = false;
    if (warning && AppContext.currentItem[field]) {
        const date = new Date(AppContext.currentItem[field]);

        if (!isNaN(date.getTime())) {
            const today = new Date();

            const todayUtc = Date.UTC(
                today.getUTCFullYear(),
                today.getUTCMonth(),
                today.getUTCDate()
            );

            const dateUtc = Date.UTC(
                date.getUTCFullYear(),
                date.getUTCMonth(),
                date.getUTCDate()
            );

            isExpired = dateUtc < todayUtc;
        }
    }

    const fieldContent = (
        <div className="view-task-field-value">
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start"
                }}
            >
                <div>
                    {isEditingField === false ? (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start"
                            }}
                        >
                            <span
                                className={`editable-field-span ${
                                    errorVar ? "form-field-error" : ""
                                }`}
                                style={
                                    isExpired
                                        ? { color: "#ec7784", fontWeight: 700 }
                                        : {}
                                }
                                onClick={() => {
                                    changeIsEditingField(true);
                                }}
                            >
                                {AppContext.currentItem[field] ? (
                                    formatDate(AppContext.currentItem[field])
                                ) : (
                                    <ItemDetailsField_EmptyValue />
                                )}
                            </span>
                        </div>
                    ) : (
                        <span style={{ width: "100%" }}>
                            <input
                                ref={fieldRef}
                                type="date"
                                style={{ width: "100%" }}
                                autoFocus={forceIsEditing != null ? false : true}
                                onBlur={() => {
                                    changeIsEditingField(false);
                                }}
                                onChange={(e) =>
                                    AppContext.setCurrentItem({
                                        ...AppContext.currentItem,
                                        [field]: e.target.value ? `${e.target.value}T00:00:00Z` : null
                                    })
                                }
                                value={dateOnly(AppContext.currentItem[field])}
                            />
                        </span>
                    )}
                </div>

                <div>
                    {errorVar && (
                        <span className="form-field-error-message">
                            The field {fieldTitle} is necessary
                        </span>
                    )}
                </div>
            </div>
        </div>
    );

    return !displayFieldOnly ? fieldContent : <>{fieldContent}</>;
};


const FieldType_ProgressBar = ({ value }) => {
    const safeProgress = Math.min(100, Math.max(0, Number(value.Progress) || 0));
    const barColor = safeProgress === 100 ? "#10b981" : "#3b82f6";

    let count = value.ActionRequiredCount + value.ActionNotRequiredCount;
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', minWidth: '100px' }}>
            <div style={{ flex: 1, height: '8px', backgroundColor: '#e5e7eb', borderRadius: '4px', overflow: 'hidden' }}>
                <div
                    style={{
                        height: '100%',
                        width: `${safeProgress}%`,
                        backgroundColor: barColor,
                        transition: 'width 0.3s ease'
                    }}
                />
            </div>
            <span style={{ fontSize: '12px', color: '#4b5563', width: '70px', textAlign: 'center', fontWeight: '500', minWidth: '70px' }}>
                {count} ({safeProgress}%)
            </span>
        </div>
    );
};

const FieldType_RedProgressBar = ({ value }) => {
    const safeProgress = Math.min(100, Math.max(0, Number(value.ActionRequiredPercentage) || 0));
    const barColor = "#ef4444"; // Red color

    let count = value.ActionRequiredCount;
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', minWidth: '100px' }}>
            <div style={{ flex: 1, height: '8px', backgroundColor: '#e5e7eb', borderRadius: '4px', overflow: 'hidden' }}>
                <div
                    style={{
                        height: '100%',
                        width: `${safeProgress}%`,
                        backgroundColor: barColor,
                        transition: 'width 0.3s ease'
                    }}
                />
            </div>
            <span style={{ fontSize: '12px', color: '#4b5563', width: '70px', textAlign: 'center', fontWeight: '500', minWidth: '70px' }}>
                {count} ({safeProgress}%)
            </span>
        </div>
    );
};

const typeList = [
    { Id: "", Name: "Choose an option" },
    { Id: "0", Name: "Product" },
    { Id: "1", Name: "QMS" },
    { Id: "2", Name: "Legal Manufacturer" },
    { Id: "3", Name: "Manufacturing" }
];

const taskPriorities = [
    { id: 1, name: "High", bgcolor: "#d1153a", color: "white" },
    { id: 2, name: "Medium", bgcolor: "#f7b204", color: "white" },
    { id: 3, name: "Low", bgcolor: "#48ca94", color: "white" },
    { id: 4, name: "None", bgcolor: "#f0f0f0", color: "#333" },
];

const FieldType_TaskName = ({ value }) => {
    const name = value && typeof value === "object" ? value.Name : value;
    const subtaskCount = value && typeof value === "object" ? value.SubtaskCount : 0;
    return (
        <div style={{ display: "flex", flexDirection: "row", minWidth: 0, alignItems: "center" }}>
            <div title={name} className="ellipsis">{name}</div>
            {subtaskCount > 0 ? (
                <div title={`${subtaskCount} Subtasks`} style={{ marginLeft: "12px", color: "#666", display: "flex", alignItems: "center", flexShrink: 0 }}>
                    <img src="/assets/images/subtask_icon.png" alt="" style={{ width: "10px", marginRight: "5px" }} />
                    {subtaskCount}
                </div>
            ) : null}
        </div>
    );
};

const FieldType_TaskCompletion = ({ value }) => {
    const isCompleted = value == 1 || value == "1" || value == "Completed";
    return (
        <div style={{
            padding: "4px",
            borderRadius: "5px",
            textAlign: "center",
            color: isCompleted ? "white" : "#333",
            backgroundColor: isCompleted ? "#00d084" : "#f0f0f0",
            width: "100px",
        }}>
            {isCompleted ? "Complete" : "Incomplete"}
        </div>
    );
};

const FieldType_TaskPriority = ({ value }) => {
    const match = taskPriorities.find((item) => item.id == value) || taskPriorities[3];
    return (
        <div style={{ padding: "4px", borderRadius: "5px", textAlign: "center", color: match.color, backgroundColor: match.bgcolor, width: "90px" }}>
            {match.name}
        </div>
    );
};

const FieldType_TaskDueDate = ({ value }) => {
    if (value == null || value === "")
        return "";
    const currentDate = new Date();
    const checkedDate = new Date(value);
    currentDate.setHours(0, 0, 0, 0);
    checkedDate.setHours(0, 0, 0, 0);
    let className = "due-date";
    if (checkedDate.getTime() < currentDate.getTime())
        className = "due-date-late";
    else if (checkedDate.getTime() === currentDate.getTime())
        className = "due-date-today";
    const month = String(checkedDate.getMonth() + 1).padStart(2, "0");
    const day = String(checkedDate.getDate()).padStart(2, "0");
    return <span className={className}>{`${checkedDate.getFullYear()}-${month}-${day}`}</span>;
};

const FieldType_TaskBoardStep = ({ value }) => {
    const [steps, setSteps] = useState(() => getTaskBoardStepsCache() || []);

    useEffect(() => {
        const cached = getTaskBoardStepsCache();
        if (cached) {
            setSteps(cached);
            return;
        }
        let cancelled = false;
        loadTaskBoards().then(() => {
            if (!cancelled)
                setSteps(getTaskBoardStepsCache() || []);
        });
        return () => { cancelled = true; };
    }, []);

    const step = steps.find((item) => item.BoardStepId == value);
    if (!step)
        return <span style={{ borderRadius: "5px", padding: "4px", backgroundColor: "#f0f0f0" }}>None</span>;
    return (
        <div>
            <i style={{ color: step.BoardStepColor, fontSize: "6pt" }} className="fas fa-circle"></i> {step.BoardStepName}
        </div>
    );
};

const FieldType_TaskEstimatedTime = ({ value }) => {
    if (value == null || value === "")
        return "";
    return <>{value}h</>;
};

const FieldType_ChangeAssessmentType = ({ value }) => {
    const safeValue = value !== null && value !== undefined ? value.toString() : "";
    const matchedType = typeList.find(t => t.Id === safeValue);
    return <span>{matchedType && matchedType.Name !== "Choose an option" ? matchedType.Name : value}</span>;
};

const StandardsRelationOriginType = ({ value }) => {

    return (
        <CMRelationOriginType origin={value} type={"standard"} />
    );
};



const RegulationsRelationOriginType = ({ value }) => {

    return (
        <CMRelationOriginType origin={value} type={"regulatory document"} />
    );
};



const CMRelationOriginType = ({ origin, type }) => {
    let name = "";
    let title = "";
    const textColor = "#757575";
    const bgColor = "#e1e1e1";

    switch (origin) {
        case "product-family":
            name = "Family";
            title = `This ${type} is linked to the family of this product`;
            break;
        case "product-skus":
            name = "Product";
            title = `This ${type} is linked to this product`;
            break;
        default:
            break;
    }

    return (
        <div
            title={title}
            style={{
                color: textColor,
                borderRadius: "5px",
                padding: "5px 8px",
                backgroundColor: bgColor,
                width: "100px",
                textAlign: "center",
                cursor: "help",
            }}
        >
            {name}
        </div>
    );
};



const TD_FORMATS = { 0: "Custom", 1: "STED", 2: "IMDRF", 3: "EU MDR", 4: "510(k)", 5: "CSTD" };

const FieldType_TD_Format = ({ value }) => {
    const label = TD_FORMATS[value] ?? "Custom";
    return (
        <span style={{
            fontSize: "11px", fontWeight: 700, letterSpacing: ".02em",
            color: "#2b6cb0", background: "#ebf8ff", border: "1px solid #bee3f8",
            borderRadius: "4px", padding: "3px 8px",
        }}>{label}</span>
    );
};

const FieldType_TD_SectionsProgress = ({ value }) => {
    const approved = value?.Approved ?? 0;
    const total = value?.Total ?? 0;
    const pct = total > 0 ? Math.round((approved / total) * 100) : 0;
    return (
        <div style={{ minWidth: "150px" }}>
            <div style={{ height: "6px", background: "#e2e8f0", borderRadius: "3px", overflow: "hidden" }}>
                <div style={{ height: "100%", width: `${pct}%`, background: total > 0 && approved === total ? "#48ca94" : "#2b6cb0" }} />
            </div>
            <div style={{ fontSize: "11px", color: "#64748b", marginTop: "3px" }}>
                {total > 0 ? `${approved}/${total} sections approved` : "No sections yet"}
            </div>
        </div>
    );
};


export {
    TD_FORMATS,
    FieldType_TD_Format,
    FieldType_TD_SectionsProgress,
    FieldType_Text,
    FieldType_MainText,
    FieldType_CategoryType,
    FieldType_Compliance_Status,
    FieldType_Compliance_Stage,
    FieldType_Open_Tasks,
    FieldType_Open_TaskCount,
    PdfLink,
    Link,
    RelatedReviews,
    RegulatoryOtherVersions,
    StandardsOtherVersions,
    SystematicReviewStatus,
    FieldType_Submission_Status,
    FieldType_Submission_Priority,
    FieldType_Submissions_Type,
    FieldType_DateList,
    FieldType_MediaPath,
    FieldType_PdfIndicator,
    FieldType_DateTimeMinutes_UTC,
    FieldType_DateTimeMinutes_UserTimeZone,
    FieldType_TruncatedDescription,
    FieldType_DocumentLink,
    FieldType_DocumentLinkWithName,
    FieldType_User,
    FieldType_FullUser, 
    FieldType_Country,
    FieldType_SRReviewMode,
    FieldType_SRCategory,
    FieldType_SRResponsiblePerson,
    FieldType_SRNotification,
    FieldType_SRItemMenu,
    FieldType_SRPendingItems,
    FieldType_SRProjectsItemMenu,
    SRListLink,
    FieldType_SimpleDate,
    FieldType_TimelineDate,
    FieldType_MultipleTimelineDates,
    LinkFileToSubmission,
    FieldType_Compliance_LegalManufacturer,
    FieldType_TagList,
    FieldType_CustomUserFieldSingleSelect,
    FieldType_CustomUserFieldMultiSelect,
    FieldType_CustomUserFields,
    FieldType_CustomUserFieldsView,
    FieldType_CountryWithFlag,
    FieldType_ProductFamily,
    FieldType_ProductRegistrationsCount,
    ItemDetailsField_EmptyValue,
    FieldType_ProductCode,
    FieldType_ProductNameArchived,
    FieldType_UdiVersion,
    FieldType_UdiRegulation,
    FieldType_ProductCountryOfOrigin,
    FieldType_ProductMadeIn,
    FieldType_ProductLegalManufacturers,
    FieldType_ProductPhysicalManufacturers,
    FieldType_ProductSPPP,
    FieldType_ProductCodeLink,
    FieldType_FamilyLink,
    FieldType_CountryRegistrationSelling,
    FieldType_RegistrationsStatus,
    FieldType_CertificateLink,
    FieldType_SubmissionLink,
    FieldType_CountryLink,
    FieldType_RiskClass,
    FieldType_MultipleOperatorsImporters, 
    FieldType_MultipleOperatorsRepresentatives, 
    FieldType_MultipleOperatorsDistributors, 
    FieldType_ListMultiRoles,
    FieldType_DateWithExpiredWarning,
    FieldType_DateWithExpiredWarningUTC,
    FieldType_RegistrationPriority,
    FieldType_CountryLinkFilterRegistrations,
    ItemDetailsField_Text,
    ItemDetailsField_Dropdown,
    FieldType_DateTime,
    ItemDetailsField_MultiSelect,
    ItemDetailsField_Image,
    ItemDetailsField_Date,
    ItemDetailsField_DateUTC,
    FieldType_ProgressBar,
    FieldType_RedProgressBar,
    FieldType_ChangeAssessmentType,
    StandardsRelationOriginType,
    RegulationsRelationOriginType,
    FieldType_TaskName,
    FieldType_TaskCompletion,
    FieldType_TaskPriority,
    FieldType_TaskDueDate,
    FieldType_TaskBoardStep,
    FieldType_TaskEstimatedTime
}